const moment = require("moment");

const { HeaderPositionType, TrayType, PaletteColorType, CalloutType, AuthoringElementType, NodeType, DEFAULT_ADDRESS, AuthoringBlockType, TextStyleType, ListStyleType, DecorationStyle, FormatType } = require("../../../constants");
const { getDefaultChartModel, getDefaultPieChartModel, getDefaultWaterfallChartModel } = require("./chartUtils");
const { uuid } = require("../../../utils/uuid");

const templates = [];

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// STRUCTURAL TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
templates.push({
    getInstanceProps: () => ({
        elementType: "PPTSlide",

        allowLayouts: false,
        allowHeader: false,
        allowFooter: false,
        allowElementCaption: false,
        allowElementAttribution: false,
        allowElementTextInline: false,
        allowElementTextTray: false,

        allowTheming: false,

        allowAnimations: false,

        allowCallouts: false,

        availableTrayLayouts: [],

        allowColorBackgrounds: false,
        allowColorful: false,

        canConvertToAuthoring: false,

        canSwitchTemplate: false,

        canMigrate: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {}
        }
    }), getStaticProps: () => ({
        id: "ppt-slide",
        icon: "authoring",
        title: "PowerPoint Slide",
        description: "",
        category: "basic",
        tags: "",
        hideTemplate: true
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "BigNumbers",

        defaultData: {
            layout: {
                slideColor: "neutral",
                backgroundColor: "background_accent",
                backgroundStyle: "backgroundAccent"
            },
            primary: {
                items: [{
                    showLabel: true,
                    showChangeInValue: true,
                    showDescription: false,
                    value: {
                        text: "$50,000",
                    },
                    label: {
                        text: "My Statistic"
                    },
                    changeLabel: {
                        text: "100%",
                    },
                    positive: true
                }]
            }
        }
    }), getStaticProps: () => ({
        id: "big-numbers",
        icon: "big_number",
        title: "Big Number",
        description: "Highlight your company metrics and impressive stats in a flexible grid.",
        category: "data",
        tags: "statistics big number value stat change amount data dashboard analytics report dollar arr mrr",
        relatedTemplates: ["thermometer", "visual_percentage"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PresentationTitle",
        variations: "title",

        allowHeader: false,
        allowFooter: false,
        allowElementCaption: false,
        allowElementAttribution: false,
        allowElementTextInline: false,
        allowElementTextTray: false,
        allowColorful: false,

        availableTrayLayouts: [],

        defaultData: {
            primary: {
                showFooter: false,
            }
        }
    }), getStaticProps: () => ({
        id: "title",
        icon: "title",
        title: "Title",
        description: "Set the stage for what's to come with a title, date, and presenter names",
        category: "organization",
        tags: "title introduction introduce speaker speakers presenter presenters intros",
        relatedTemplates: ["headline2", "section"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Agenda",
        headerPosition: HeaderPositionType.TOP,
        variations: "list",

        allowElementTitle: false,
        allowElementCaption: false,
        allowElementAttribution: false,
        allowColorful: true,

        defaultData: {
            primary: {
                items: [],
            }
        }
    }), getStaticProps: () => ({
        id: "agenda",
        icon: "agenda",
        title: "Agenda",
        description: "Prepare your audience for the structure of your presentation",
        category: "organization",
        tags: "q&A question answer segue transition agenda schedule steps objective goal OKR table contents",
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// TEXT TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "TextSlide",
        allowColorful: false,
        defaultData: {
            primary: {}
        }
    }), getStaticProps: () => ({
        id: "text",
        icon: "text",
        title: "Text",
        description: "There's a time and place for lengthy paragraphs. Be sure not to overwhelm your audience with information!",
        category: "basic",
        tags: "disclaimer text paragraph",
        relatedTemplates: ["textlist", "textBoxGrid"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "TextList",
        variations: "list",

        defaultImageTrayType: TrayType.RIGHT_TRAY,
        allowColorful: true,

        defaultData: {
            primary: {
                items: [],
                listStyle: "bullets"
            }
        }
    }), getStaticProps: () => ({
        id: "textlist",
        icon: "textgrid_bullets",
        title: "Bullet List",
        description: "Get the main point across with a concise list of headlines",
        category: "basic popular",
        tags: "bullet update status points text message messages values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished make a list services solution key takeaway highlight priority case study product features",
        relatedTemplates: ["textBoxGrid", "textgrid_vertical_icons", "textgrid_photos", "textgrid_carousel", "arrow_bars", "step_boxes"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "TextBoxGrid",
        variations: "list",
        // availableHeaderPositions: [HeaderPositionType.TOP],

        allowColorful: true,

        defaultData: {
            "primary": {
                "items": [{}, {}, {}, {}],
                "flipOrientation": false
            }
        }
    }), getStaticProps: () => ({
        id: "textBoxGrid",
        icon: "textBoxGrid",
        title: "Text Boxes",
        description: "Display your list items in compartments to create visual separation",
        category: "popular basic",
        tags: "objectives goals forces bullet update status points text message messages values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished make a list services solution key takeaway highlight priority case study product features strategy strategic strategies persona solution service list",
        relatedTemplates: ["textlist", "textgrid_vertical_icons", "textgrid_photos", "textgrid_carousel", "arrow_bars", "step_boxes"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "IconTextGrid",
        variations: "list",
        allowColorful: true,

        defaultData: {
            "primary": {
                "forceSingleColumn": false,
                "items": [
                    {
                        "content_type": "icon",
                        "title": "",
                        "body": "",
                        "content_value": ""
                    },
                    {
                        "content_type": "icon",
                        "title": "",
                        "body": "",
                        "content_value": ""
                    },
                    {
                        "content_type": "icon",
                        "title": "",
                        "body": "",
                        "content_value": ""
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "textgrid_vertical_icons",
        icon: "textgrid_vertical_icons",
        title: "Icon List",
        description: "Decorate each of your points with an icon that adds visual emphasis.",
        category: "basic popular",
        tags: "customers problem icons text compete competitors competitor competition messages message make a list items category categories reasons values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished services solution key takeaway highlight priority bullet update status points case study landscape product features call to action results business objective goal OKR price pricing",
        relatedTemplates: ["textlist", "textBoxGrid", "textgrid_photos", "textgrid_carousel", "arrow_bars", "step_boxes"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ImageCarousel",

        canConvertToAuthoring: true,
        allowColorful: true,

        defaultData: {
            "primary": {
                items: [{ id: uuid() }],
            }
        }
    }), getStaticProps: () => ({
        id: "textgrid_carousel",
        icon: "textgrid_carousel",
        title: "Image Carousel",
        description: "Create a relationship between sequential messages with this flip-through carousel.",
        category: "basic",
        tags: "persona procedure schedule big problem objective goal OKR carousel process message messages steps idea build values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished make a list photo photos photographs images pictures services solution key takeaway highlight priority bullet update status points photos text",
        relatedTemplates: ["textlist", "textBoxGrid", "textgrid_photos", "textgrid_vertical_icons", "arrow_bars", "step_boxes"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoTextList",
        variations: "list",

        defaultData: {
            primary: {
                items: [{}, {}, {}]
            }
        },

        availableTrayLayouts: [],
        allowColorful: true,
    }), getStaticProps: () => ({
        id: "textgrid_photos",
        icon: "textgrid_photos",
        title: "Image with Text",
        description: "Use visuals to bring your main points to life.",
        category: "basic",
        tags: "persona partners partnerships pr press customers problem speaker intros team culture members teammates objective goal OKR screenshot shot screen compete competitors competitor competition messages message make a list items category categories reasons values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished photo photos photographs images pictures services solution key takeaway highlight priority bullet update status points case study landscape call to action image text product features",
        relatedTemplates: ["textlist", "textBoxGrid", "textgrid_carousel", "textgrid_vertical_icons", "arrow_bars", "step_boxes"],
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// PhotoCollage TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",
        variations: "list",

        allowHeader: true,
        availableTrayLayouts: [],
        allowElementAttribution: false,
        allowFooter: true,
        preventDefaultFooter: true,
        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
                showGutter: false,
                fullBleed: true,
                matchTextScale: true,
                items: [{ id: uuid(), componentType: "TextAndImage" }],
            }
        }
    }), getStaticProps: () => ({
        id: "image",
        icon: "image",
        title: "Image",
        description: "Grab your audience's attention with a big image. You can easily add a quote or text caption.",
        category: "impact basic",
        tags: "logo team picture image photo photos photographs images pictures emotional inspire audience inspiration emotion impact feelings",
        relatedTemplates: ["collage", "textgrid_photos", "video", "product_laptop"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",
        variations: "list",

        availableHeaderPositions: [HeaderPositionType.TOP, HeaderPositionType.LEFT],
        availableTrayLayouts: [],

        allowHeader: true,
        allowElementAttribution: true,
        allowFooter: true,
        preventDefaultFooter: true,
        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
                gridLayout: {
                    cols: 12, rows: 12, cells: [{
                        x: 0, y: 0, width: 6, height: 6
                    }, {
                        x: 6, y: 0, width: 6, height: 6
                    }, {
                        x: 0, y: 6, width: 6, height: 6
                    }, {
                        x: 6, y: 6, width: 6, height: 6
                    }]
                },
                layoutType: "grid",
                showGutter: true,
                fullBleed: true,
                items: [
                    { id: uuid(), componentType: "TextAndImage" },
                    { id: uuid(), componentType: "TextAndImage" },
                    { id: uuid(), componentType: "TextAndImage" },
                    { id: uuid(), componentType: "TextAndImage" }
                ],
            }
        }
    }), getStaticProps: () => ({
        id: "collage",
        icon: "collage",
        title: "Image Grid",
        description: "Create a variety of layouts with text, photos, and icons in this responsive grid.",
        category: "basic impact popular",
        tags: "portfolio team problem accomplish accomplishments accomplished photo photos photographs image grid images pictures emotional inspire audience inspiration emotion impact feelings product screenshots screen shots",
        relatedTemplates: ["image", "textgrid_photos"],
    })
});

// -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// Headline templates
// -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

// region OldImageGridTemplates
// these are the previous imageGrid templates that have been replaced with headline templates
// we need to keep the previous templates so that slides created prior to the layout refactor of Oct 2018 are consistent
// but they are hidden from the AddSlide dialog

// endregion

// new headline templates

templates.push({
    getInstanceProps: () => ({
        elementType: "Headline",

        availableTrayLayouts: [],

        allowFooter: true,
        allowHeader: false,
        preventDefaultFooter: true,
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,

        defaultData: {
            primary: {
                fullBleed: true,
                showGutter: true,
                text: {
                    blocks: [{
                        textStyle: "headline"
                    }]
                }
            }
        },
    }), getStaticProps: () => ({
        id: "headline2",
        icon: "headline",
        title: "Headline",
        description: "Emphasize your point with large text. Add images to make it more visual.",
        category: "impact popular",
        tags: "thank big segue transition share our mission provocative question call to action vision differentiate differentiator proposition propositions powerful bold summary summarize message statement accomplish accomplishments accomplished photo photos photographs images pictures emotional inspire audience inspiration emotion impact feelings key takeaway highlight big headline and culture text",
        relatedTemplates: ["section"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Headline",

        availableTrayLayouts: [],

        allowFooter: true,
        preventDefaultFooter: true,
        allowHeader: false,
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,

        defaultData: {
            primary: {
                text: {
                    blocks: [
                        {
                            id: "label",
                            type: AuthoringBlockType.TEXT,
                            textStyle: TextStyleType.LABEL,
                            html: "Section 1"
                        },
                        {
                            id: "headline",
                            type: AuthoringBlockType.TEXT,
                            textStyle: TextStyleType.HEADLINE,
                            html: ""
                        }
                    ]
                },
                fullBleed: true,
                showGutter: true
            },
            layout: {
                backgroundColor: "theme",
                backgroundStyle: "backgroundColor"
            }
        },

        version: 2,
    }), getStaticProps: () => ({
        id: "section",
        icon: "section_break",
        title: "Section Break",
        description: "Leverage section breaks for transitional ideas, questions, and physical relief during long presentations.",
        category: "organization",
        tags: "question introduction introduce chapter section transition segue transition header",
        relatedTemplates: ["headline2"],
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// MISC TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "WordCloudElement",

        allowElementAttribution: false,

        allowColorful: true,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE,
            },
            primary: {
                style: "right_angles",
                sort: "size",
                scale: 25,
                calculatedWidth: 1180,
                calculatedHeight: 620,
                version: 2,
                wordcloud: "[{\"word\":\"magic\",\"weight\":\"1\",\"layout\":{\"x\":1486,\"y\":790,\"rotation\":0,\"offsetX\":-23.912490844726562,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"designer\",\"weight\":\"1\",\"layout\":{\"x\":1054,\"y\":874,\"rotation\":0,\"offsetX\":-36.58747863769531,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"software\",\"weight\":\"1\",\"layout\":{\"x\":1402,\"y\":842,\"rotation\":0,\"offsetX\":-39.937469482421875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"easy\",\"weight\":\"1\",\"layout\":{\"x\":866,\"y\":778,\"rotation\":0,\"offsetX\":-19.22498321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"automatic\",\"weight\":\"1\",\"layout\":{\"x\":792,\"y\":540,\"rotation\":90,\"offsetX\":-42.48747253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"themes\",\"weight\":\"1\",\"layout\":{\"x\":1056,\"y\":366,\"rotation\":0,\"offsetX\":-30.42498016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"template\",\"weight\":\"1\",\"layout\":{\"x\":1312,\"y\":366,\"rotation\":0,\"offsetX\":-38.42497253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"web\",\"weight\":\"1\",\"layout\":{\"x\":1414,\"y\":426,\"rotation\":0,\"offsetX\":-16.712493896484375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"timeline\",\"weight\":\"1\",\"layout\":{\"x\":1556,\"y\":526,\"rotation\":0,\"offsetX\":-34.73748016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"wordcloud\",\"weight\":\"1\",\"layout\":{\"x\":1332,\"y\":862,\"rotation\":0,\"offsetX\":-46.199974060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"chart\",\"weight\":\"1\",\"layout\":{\"x\":1346,\"y\":386,\"rotation\":0,\"offsetX\":-24.7249755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"product\",\"weight\":\"1\",\"layout\":{\"x\":796,\"y\":696,\"rotation\":90,\"offsetX\":-34.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"icons\",\"weight\":\"1\",\"layout\":{\"x\":1492,\"y\":766,\"rotation\":0,\"offsetX\":-22.16248321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"images\",\"weight\":\"1\",\"layout\":{\"x\":1234,\"y\":870,\"rotation\":0,\"offsetX\":-28.36248779296875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"pictures\",\"weight\":\"1\",\"layout\":{\"x\":1498,\"y\":466,\"rotation\":0,\"offsetX\":-35.637474060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"filters\",\"weight\":\"1\",\"layout\":{\"x\":984,\"y\":838,\"rotation\":0,\"offsetX\":-29.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"grid\",\"weight\":\"1\",\"layout\":{\"x\":874,\"y\":468,\"rotation\":-90,\"offsetX\":-17.37499237060547,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"diagram\",\"weight\":\"1\",\"layout\":{\"x\":1536,\"y\":728,\"rotation\":90,\"offsetX\":-34.29998016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"magic\",\"weight\":\"1\",\"layout\":{\"x\":1506,\"y\":486,\"rotation\":0,\"offsetX\":-23.912490844726562,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"designer\",\"weight\":\"1\",\"layout\":{\"x\":910,\"y\":434,\"rotation\":0,\"offsetX\":-36.58747863769531,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"software\",\"weight\":\"1\",\"layout\":{\"x\":1406,\"y\":822,\"rotation\":0,\"offsetX\":-39.937469482421875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"easy\",\"weight\":\"1\",\"layout\":{\"x\":898,\"y\":790,\"rotation\":90,\"offsetX\":-19.22498321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"automatic\",\"weight\":\"1\",\"layout\":{\"x\":1140,\"y\":870,\"rotation\":0,\"offsetX\":-42.48747253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"themes\",\"weight\":\"1\",\"layout\":{\"x\":1566,\"y\":620,\"rotation\":-90,\"offsetX\":-30.42498016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"template\",\"weight\":\"1\",\"layout\":{\"x\":1128,\"y\":366,\"rotation\":0,\"offsetX\":-38.42497253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"web\",\"weight\":\"1\",\"layout\":{\"x\":878,\"y\":758,\"rotation\":0,\"offsetX\":-16.712493896484375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"timeline\",\"weight\":\"1\",\"layout\":{\"x\":792,\"y\":620,\"rotation\":-90,\"offsetX\":-34.73748016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"wordcloud\",\"weight\":\"1\",\"layout\":{\"x\":1216,\"y\":366,\"rotation\":0,\"offsetX\":-46.199974060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"chart\",\"weight\":\"1\",\"layout\":{\"x\":1294,\"y\":386,\"rotation\":0,\"offsetX\":-24.7249755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"product\",\"weight\":\"1\",\"layout\":{\"x\":1324,\"y\":842,\"rotation\":0,\"offsetX\":-34.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"icons\",\"weight\":\"1\",\"layout\":{\"x\":1382,\"y\":412,\"rotation\":90,\"offsetX\":-22.16248321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"images\",\"weight\":\"1\",\"layout\":{\"x\":1446,\"y\":446,\"rotation\":90,\"offsetX\":-28.36248779296875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"pictures\",\"weight\":\"1\",\"layout\":{\"x\":978,\"y\":818,\"rotation\":0,\"offsetX\":-35.637474060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"filters\",\"weight\":\"1\",\"layout\":{\"x\":1516,\"y\":642,\"rotation\":0,\"offsetX\":-29.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"grid\",\"weight\":\"1\",\"layout\":{\"x\":1350,\"y\":532,\"rotation\":-90,\"offsetX\":-17.37499237060547,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"diagram\",\"weight\":\"1\",\"layout\":{\"x\":820,\"y\":700,\"rotation\":90,\"offsetX\":-34.29998016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"magic\",\"weight\":\"1\",\"layout\":{\"x\":1510,\"y\":718,\"rotation\":90,\"offsetX\":-23.912490844726562,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"designer\",\"weight\":\"1\",\"layout\":{\"x\":1518,\"y\":594,\"rotation\":0,\"offsetX\":-36.58747863769531,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"software\",\"weight\":\"1\",\"layout\":{\"x\":924,\"y\":802,\"rotation\":90,\"offsetX\":-39.937469482421875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"easy\",\"weight\":\"1\",\"layout\":{\"x\":1258,\"y\":554,\"rotation\":90,\"offsetX\":-19.22498321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"automatic\",\"weight\":\"1\",\"layout\":{\"x\":992,\"y\":426,\"rotation\":0,\"offsetX\":-42.48747253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"themes\",\"weight\":\"1\",\"layout\":{\"x\":1490,\"y\":724,\"rotation\":-90,\"offsetX\":-30.42498016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"template\",\"weight\":\"1\",\"layout\":{\"x\":1324,\"y\":822,\"rotation\":0,\"offsetX\":-38.42497253417969,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"web\",\"weight\":\"1\",\"layout\":{\"x\":1310,\"y\":734,\"rotation\":0,\"offsetX\":-16.712493896484375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"timeline\",\"weight\":\"1\",\"layout\":{\"x\":988,\"y\":798,\"rotation\":0,\"offsetX\":-34.73748016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"wordcloud\",\"weight\":\"1\",\"layout\":{\"x\":844,\"y\":712,\"rotation\":90,\"offsetX\":-46.199974060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"chart\",\"weight\":\"1\",\"layout\":{\"x\":1470,\"y\":718,\"rotation\":-90,\"offsetX\":-24.7249755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"product\",\"weight\":\"1\",\"layout\":{\"x\":1512,\"y\":618,\"rotation\":0,\"offsetX\":-34.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"icons\",\"weight\":\"1\",\"layout\":{\"x\":1012,\"y\":446,\"rotation\":0,\"offsetX\":-22.16248321533203,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"images\",\"weight\":\"1\",\"layout\":{\"x\":1006,\"y\":466,\"rotation\":0,\"offsetX\":-28.36248779296875,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"pictures\",\"weight\":\"1\",\"layout\":{\"x\":1442,\"y\":486,\"rotation\":0,\"offsetX\":-35.637474060058594,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"filters\",\"weight\":\"1\",\"layout\":{\"x\":1372,\"y\":494,\"rotation\":0,\"offsetX\":-29.0374755859375,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"grid\",\"weight\":\"1\",\"layout\":{\"x\":1272,\"y\":734,\"rotation\":0,\"offsetX\":-17.37499237060547,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"diagram\",\"weight\":\"1\",\"layout\":{\"x\":1128,\"y\":612,\"rotation\":-90,\"offsetX\":-34.29998016357422,\"offsetY\":2.5,\"fontSize\":25,\"weight\":\"1\"},\"drawn\":true},{\"word\":\"timeline\",\"weight\":\"2\",\"layout\":{\"x\":822,\"y\":536,\"rotation\":90,\"offsetX\":-69.4749755859375,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"wordcloud\",\"weight\":\"2\",\"layout\":{\"x\":1024,\"y\":396,\"rotation\":0,\"offsetX\":-92.39996337890625,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"chart\",\"weight\":\"2\",\"layout\":{\"x\":1320,\"y\":416,\"rotation\":0,\"offsetX\":-49.449974060058594,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"product\",\"weight\":\"2\",\"layout\":{\"x\":1396,\"y\":792,\"rotation\":0,\"offsetX\":-68.07496643066406,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"icons\",\"weight\":\"2\",\"layout\":{\"x\":876,\"y\":704,\"rotation\":-90,\"offsetX\":-44.324981689453125,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"images\",\"weight\":\"2\",\"layout\":{\"x\":864,\"y\":548,\"rotation\":-90,\"offsetX\":-56.72498321533203,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"pictures\",\"weight\":\"2\",\"layout\":{\"x\":1186,\"y\":396,\"rotation\":0,\"offsetX\":-71.27497100830078,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"filters\",\"weight\":\"2\",\"layout\":{\"x\":1462,\"y\":516,\"rotation\":0,\"offsetX\":-58.074981689453125,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"grid\",\"weight\":\"2\",\"layout\":{\"x\":1440,\"y\":726,\"rotation\":-90,\"offsetX\":-34.74999237060547,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"diagram\",\"weight\":\"2\",\"layout\":{\"x\":1496,\"y\":672,\"rotation\":0,\"offsetX\":-68.5999755859375,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"magic\",\"weight\":\"2\",\"layout\":{\"x\":916,\"y\":714,\"rotation\":-90,\"offsetX\":-47.824981689453125,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"designer\",\"weight\":\"2\",\"layout\":{\"x\":906,\"y\":532,\"rotation\":-90,\"offsetX\":-73.17498016357422,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"software\",\"weight\":\"2\",\"layout\":{\"x\":1486,\"y\":556,\"rotation\":0,\"offsetX\":-79.87496948242188,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"easy\",\"weight\":\"2\",\"layout\":{\"x\":1366,\"y\":752,\"rotation\":0,\"offsetX\":-38.449981689453125,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"automatic\",\"weight\":\"2\",\"layout\":{\"x\":1348,\"y\":456,\"rotation\":0,\"offsetX\":-84.97496032714844,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"themes\",\"weight\":\"2\",\"layout\":{\"x\":956,\"y\":728,\"rotation\":-90,\"offsetX\":-60.8499755859375,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"template\",\"weight\":\"2\",\"layout\":{\"x\":946,\"y\":524,\"rotation\":-90,\"offsetX\":-76.84996795654297,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"web\",\"weight\":\"2\",\"layout\":{\"x\":1384,\"y\":540,\"rotation\":-90,\"offsetX\":-33.42498779296875,\"offsetY\":5,\"fontSize\":50,\"weight\":\"2\"},\"drawn\":true},{\"word\":\"colors\",\"weight\":\"3\",\"layout\":{\"x\":890,\"y\":634,\"rotation\":0,\"offsetX\":-85.98748016357422,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"strategies\",\"weight\":\"3\",\"layout\":{\"x\":1150,\"y\":834,\"rotation\":0,\"offsetX\":-133.01246643066406,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"diversity\",\"weight\":\"3\",\"layout\":{\"x\":1152,\"y\":446,\"rotation\":0,\"offsetX\":-115.7249755859375,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"disruptive\",\"weight\":\"3\",\"layout\":{\"x\":1198,\"y\":774,\"rotation\":0,\"offsetX\":-129.93746948242188,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"layout\",\"weight\":\"3\",\"layout\":{\"x\":1344,\"y\":698,\"rotation\":0,\"offsetX\":-83.54998016357422,\"offsetY\":7.5,\"fontSize\":75,\"weight\":\"3\"},\"drawn\":true},{\"word\":\"work\",\"weight\":\"4\",\"layout\":{\"x\":1394,\"y\":614,\"rotation\":0,\"offsetX\":-88.74998474121094,\"offsetY\":10,\"fontSize\":100,\"weight\":\"4\"},\"drawn\":true},{\"word\":\"smart\",\"weight\":\"4\",\"layout\":{\"x\":1156,\"y\":706,\"rotation\":0,\"offsetX\":-103.99998474121094,\"offsetY\":10,\"fontSize\":100,\"weight\":\"4\"},\"drawn\":true},{\"word\":\"simple\",\"weight\":\"4\",\"layout\":{\"x\":1014,\"y\":678,\"rotation\":-90,\"offsetX\":-109.44998168945312,\"offsetY\":10,\"fontSize\":100,\"weight\":\"4\"},\"drawn\":true},{\"word\":\"Beautiful\",\"weight\":\"5\",\"layout\":{\"x\":1162,\"y\":524,\"rotation\":0,\"offsetX\":-200.375,\"offsetY\":12.5,\"fontSize\":125,\"weight\":\"5\"},\"drawn\":true},{\"word\":\"Slides\",\"weight\":\"5\",\"layout\":{\"x\":1178,\"y\":620,\"rotation\":0,\"offsetX\":-128.3125,\"offsetY\":12.5,\"fontSize\":125,\"weight\":\"5\"},\"drawn\":true}]"
            }
        }

    }), getStaticProps: () => ({
        id: "wordCloud",
        icon: "word_cloud",
        title: "Word Cloud",
        description: "Highlight the main sentiment in a cluster of related words.",
        category: "impact",
        tags: "visual word cloud text survey results impact idea big findings concept map wordle",
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// PRODUCT TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "ProductScreenshot",

        availableTrayLayouts: [],
        allowColorful: true,

        defaultData: {
            primary: {
                listStyle: "bullets",
                items: [
                    {
                        isMedia: true,
                        size: 700,
                        text: null,
                        frameType: "apple_macbook_space_grey",
                    },
                    {
                        isMedia: false,
                        text: {
                            blocks: [
                                {
                                    type: "text",
                                    listStyle: ListStyleType.BULLET,
                                    textStyle: TextStyleType.BULLET_LIST,
                                    indent: 0,
                                    html: "",
                                },
                                {
                                    type: "text",
                                    listStyle: ListStyleType.TEXT,
                                    textStyle: TextStyleType.BULLET_LIST,
                                    indent: 1,
                                    html: "",
                                }
                            ]
                        },
                    }
                ],
                showColumnHeaders: false,
                startNum: 1
            }
        },
    }), getStaticProps: () => ({
        id: "product_laptop",
        icon: "product_laptop",
        title: "Product Screenshot",
        description: "Illustrate feature capabilities, design, and UX across just about any device.",
        category: "product",
        tags: "display product laptop desktop screenshot callouts features monitor screen shots pc device callout features mobile phone iphone android device mac feature features benefit benefits annotation differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions photo photos photographs images pictures demo",
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// DIAGRAM TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "VennDiagram",
        variations: "compare",

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                collectionColor: "colorful",
                items: [
                    {
                        x: 0,
                        y: -100,
                        radius: 150,
                        label: ""
                    },
                    {
                        x: -100,
                        y: 100,
                        radius: 150,
                        label: ""
                    },
                    {
                        x: 100,
                        y: 100,
                        radius: 150,
                        label: ""
                    }
                ]
            }
        },

    }), getStaticProps: () => ({
        id: "vennDiagram",
        icon: "venn_diagram",
        title: "Venn Diagram",
        description: "Show how multiple ideas vary in size and overlap.",
        category: "comparisons",
        tags: "competitive landscape quadrant xy plot chart share hierarchy set relationship market compare groups us vs them advantages comparison overlap competition competitor relative more less same better worse big small attributes qualities circles bubbles factors",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "XYGraph",
        variations: "xygraph",

        allowColorBackgrounds: false,
        allowColorful: true,

        allowCallouts: true,

        defaultData: {
            primary: {
                collectionColor: "colorful",
                yAxisLabel: "Ability to Execute",
                xAxisLabel: "Completeness of Vision",
                showArrowHeads: true,
                showAxis: true,
                axisPosition: "left",
                showAxisLabels: true,
                showGrid: true,
                gridSize: 34,
                showQuadrants: false,
                showQuadrantLabels: false,
                label1: "Challengers",
                label2: "Leaders",
                label3: "Niche Players",
                label4: "Visionaries",
                data: [{
                    id: uuid(),
                    x: 0.10,
                    y: 0.8,
                    calloutType: CalloutType.FLEX_CIRCLE,
                    type: "callout",
                    textDirection: "auto",
                    size: 50,
                    label: "Item #1"
                }, {
                    id: uuid(),
                    x: 0.5,
                    y: 0.5,
                    calloutType: CalloutType.FLEX_CIRCLE,
                    type: "callout",
                    textDirection: "auto",
                    size: 150,
                    label: "Item #2"
                }, {
                    id: uuid(),
                    x: 0.8,
                    y: 0.25,
                    calloutType: CalloutType.FLEX_CIRCLE,
                    type: "callout",
                    textDirection: "auto",
                    size: 200,
                    label: "Item #3"
                }]
            }
        }
    }), getStaticProps: () => ({
        id: "xygraph",
        icon: "xy_axis",
        title: "XY Plot",
        description: "Communicate relationships, patterns, and priorities of items plotted against two key metrics.",
        category: "comparisons",
        tags: "persona competitive landscape venn quadrant share pro con size group circles bubbles hierarchy set plot scatter scatterplot dimension axis axes cluster relationship market compare groups us vs them advantanges comparison competition competitor relative more less same better worse big small attributes qualities scattergram",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "SwotDiagram",

        availableHeaderPositions: [HeaderPositionType.TOP],
        availableTrayLayouts: [],
        allowColorful: true,

        defaultData: {
            "primary": {
                "showCellTitle": true,
                "showCellChar": true,
                "showAxisLabel": false,
                "items": [
                    {
                        text: {
                            blocks: [{
                                id: "title",
                                html: "Strengths",
                                type: AuthoringBlockType.TEXT,
                                textStyle: TextStyleType.TITLE
                            }, {
                                id: "body",
                                html: "",
                                type: AuthoringBlockType.TEXT,
                                textStyle: TextStyleType.BODY
                            }]
                        },
                    },
                    {
                        text: {
                            blocks: [{
                                id: "title",
                                html: "Weaknesses",
                                type: AuthoringBlockType.TEXT,
                                textStyle: TextStyleType.TITLE
                            }, {
                                id: "body",
                                html: "",
                                type: AuthoringBlockType.TEXT,
                                textStyle: TextStyleType.BODY
                            }]
                        },
                    },
                    {
                        text: {
                            blocks: [{
                                id: "title",
                                html: "Opportunities",
                                type: AuthoringBlockType.TEXT,
                                textStyle: TextStyleType.TITLE
                            }, {
                                id: "body",
                                html: "",
                                type: AuthoringBlockType.TEXT,
                                textStyle: TextStyleType.BODY
                            }]
                        },
                    },
                    {
                        text: {
                            blocks: [{
                                id: "title",
                                html: "Threats",
                                type: AuthoringBlockType.TEXT,
                                textStyle: TextStyleType.TITLE
                            }, {
                                id: "body",
                                html: "",
                                type: AuthoringBlockType.TEXT,
                                textStyle: TextStyleType.BODY
                            }]
                        },
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "swot_diagram",
        icon: "swot_diagram",
        title: "SWOT Analysis",
        category: "comparisons",
        description: "Highlight key results of a SWOT assessment.",
        tags: "strength weakness opportunity threat advantage disadvantage difference differentiate differentiator factors internal external strategy strategic plan planning",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Thermometer",
        allowCallouts: true,
        defaultData: {
            primary: {
                showBulb: true,
                value: 50,
                tickCount: 5,
                targetMax: 100,
                valuePosition: "fluidTop"
            }
        }
    }), getStaticProps: () => ({
        id: "thermometer",
        category: "data",
        title: "Thermometer",
        tags: "thermometer, percent",
        icon: "thermometer",
        description: "Show progress toward a single goal with this dynamic, animated thermometer.",
        relatedTemplates: ["big-numbers", "visual_percentage"]
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Countdown",

        defaultData: {
            primary: {
                date: moment().startOf("day").add(10, "days").format("M/D/YYYY"),
                time: "5:00 PM",
                showSeconds: true
            }
        },

        allowHeader: true,
        allowFooter: true,
        allowColorful: true,
    }), getStaticProps: () => ({
        hideTemplate: false,
        id: "countdown",
        icon: "countdown",
        title: "Countdown",
        description: "Build anticipation leading up to a launch or deadline with an animated Countdown slide.",
        category: "impact",
        tags: "date future time count countdown timer",
        isNew: true,
        relatedTemplates: ["timer"]
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Timer",

        defaultData: {
            primary: {
                duration: 5 * 60, // default to 5 minutes
                emphasize: 60
            }
        },

        allowHeader: true,
        allowFooter: true,
        allowColorful: true,
    }), getStaticProps: () => ({
        hideTemplate: false,
        id: "timer",
        icon: "timer",
        title: "Timer",
        description: "This animated timer is perfect for shorter periods of time, like a coffee break or Q+A session.",
        category: "impact",
        tags: "date future time count countdown timer",
        isNew: true,
        relatedTemplates: ["countdown"]
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ArrowBars",
        variations: "compare",

        availableTrayLayouts: [TrayType.RIGHT_TRAY, TrayType.RIGHT_INLINE],
        availableHeaderPositions: [HeaderPositionType.TOP],
        allowColorful: true,

        defaultData: {
            primary: {
                showIndex: true,
                showFoldEffect: true,
                items: [
                    {
                        value: 33,
                        showArrowHead: true,
                        label: ""
                    },
                    {
                        value: 50,
                        showArrowHead: true,
                        label: ""
                    },
                    {
                        value: 75,
                        showArrowHead: true,
                        label: ""
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "arrow_bars",
        icon: "arrow_bars",
        title: "Arrow Bars",
        description: "Depict hierarchy and sequence by adjusting items' vertical and horizontal rank and space.",
        category: "comparisons",
        tags: "progress relative initiative initiatives compete competitors competitor competition grow growing growth data shrink shrinking shrink bigger big large larger small smaller faster slower fast slow grew shrunk change changed changing grown feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions better worse faster slower more less higher lower make a head-to-head comparison relationship landscape infographic",
        relatedTemplates: ["textlist", "textgrid_vertical_icons", "textgrid_photos", "compare_horizontal_bars"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "RadialBarChart",
        variations: "compare",

        allowColorful: true,

        defaultData: {
            primary: {
                collectionColor: "theme-to-light",
                trackStyle: "bar",
                showGrid: false,
                maxValue: 100,
                startPosition: "top",
                items: [
                    {
                        value: 33,
                        label: ""
                    },
                    {
                        value: 50,
                        label: ""
                    },
                    {
                        value: 75,
                        label: ""
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "radial_bar_chart",
        icon: "radial_bar_chart",
        title: "Radial Bar Chart",
        description: "Compare progress or outcomes across items with a shared objective.",
        category: "comparisons",
        tags: "bar chart polar circular circle compare comparison radial percentage coordinate visual concentric",
        relatedTemplates: ["compare_vertical_bars", "compare_horizontal_bars", "compare_circles", "compare_radial_bars", "compare_vertical_pictograph", "slicechart", "chart_column", "chart_bar", "chart_pie"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Pyramid",
        variations: "pyramid",

        availableHeaderPositions: [HeaderPositionType.TOP],
        allowColorful: true,

        defaultData: {
            "primary": {
                "inverted": false,
                "color": "accent1",
                "showDescription": true,
                capSize: 0,
                baseSize: 60,
                step: false,
                capAlign: "center",
                collectionColor: "theme-to-light",
                decorationStyle: DecorationStyle.FILLED,
                "items": [{}, {}, {}]
            }
        }
    }), getStaticProps: () => ({
        id: "pyramid",
        icon: "pyramid",
        title: "Pyramid",
        description: "Show hierarchy by size, quantity, or priority with this flexible, customizable graphic.",
        category: "diagram",
        tags: "pipeline price pricing market size pyramid hierarchy diagram message messages compete competitors competitor competition shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown values feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions percent percentage landscape org structure",
        relatedTemplates: ["funnel", "target", "horizontal-funnel"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Pyramid",
        variations: "pyramid",

        availableHeaderPositions: [HeaderPositionType.TOP],
        allowColorful: true,

        defaultData: {
            primary: {
                showDescription: true,
                capSize: 65,
                baseSize: 15,
                step: false,
                inverted: false,
                capAlign: "center",
                collectionColor: "theme-to-light",
                decorationStyle: DecorationStyle.FILLED,
                items: [{}, {}, {}],
            }
        }
    }), getStaticProps: () => ({
        id: "funnel",
        icon: "funnel",
        title: "Funnel",
        description: "Illustrate dropoff between steps in a flow.",
        category: "diagram",
        tags: "procedure schedule pipeline traction marketing market funnel process filter percent percentage progress move movement churn retention step",
        relatedTemplates: ["pyramid", "target", "horizontal-funnel"],
    })
});

// const visual_big_stat = createTemplate({
//     elementType: "CompareGrid",
//     showHeader: true,
//
//     defaultData: {
//         items: [
//             {
//                 value: 25,
//             },
//             {
//                 value: 50,
//             }
//         ]
//     },
//
// }, {
//     id: "visual_big_stat",
//     icon: "visual_big_stat",
//     variations: "radial",
//     title: "Visual Stat",
//     description: "Highlight a single statistic visually and punctuate it with an image.",
//     category: "data",
//     tags: "case study compare column pie chart donut chart goal OKR chart compare vs infographic change compete competitors competitor competition grow growing data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results business percent percentage progress better worse faster slower more less higher lower metrics performance business performance business over time churn retention make a head-to-head comparison relationship market share stat statistic growth projections categories"
// }});

templates.push({
    getInstanceProps: () => ({
        elementType: "Target",

        // variations: "target",

        defaultData: {
            primary: {
                innerRadius: 0,
                collectionColor: "colorful",
                items: [
                    {
                        id: uuid(),
                        segments: [{}],
                    },
                    {
                        id: uuid(),
                        segments: [{}],
                    },
                    {
                        id: uuid(),
                        segments: [{}],
                    }
                ]
            }
        },

        allowColorBackgrounds: false,

    }), getStaticProps: () => ({
        id: "target",
        icon: "target_chart",
        title: "Target",
        description: "Illustrate how elements radiate from or build upon a core concept or goal.",
        category: "diagram",
        tags: "progress categories goal result head-to-head comparison relationship target circle concentric segment inner arrow relationship",
        relatedTemplates: ["funnel", "pyramid"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PictorialCharts",
        variations: "compare",

        showHeader: false,
        allowColorful: true,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE,
            },
            primary: {
                fitIcons: true,
                items: [
                    {
                        value: 75,
                        shape: "male",
                        description: {
                            blocks: [{
                                html: "",
                                textStyle: "body",
                                type: "text",
                            }]
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "visual_percentage",
        icon: "visual_percentage",
        title: "Percentage with Icons",
        description: "Use this infographic slide to highlight progress metrics with contextual iconography.",
        category: "data",
        tags: "case study compare column pie chart donut chart big stat problem growth percent percentage survey poll results business churn retention data icon stat statistic infographic pictograph",
        relatedTemplates: ["big-numbers", "thermometer"],
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// CHART TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",
        variations: "tabular",

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                gridLayout: {
                    cols: 12, rows: 12,
                    cells: [{
                        x: 0, y: 0, width: 8, height: 12
                    }, {
                        x: 8, y: 0, width: 4, height: 6
                    }, {
                        x: 8, y: 6, width: 4, height: 6
                    }]
                },
                items: [
                    {
                        componentType: "Chart",
                        childElement: {
                            ...getDefaultChartModel("column")
                        }
                    }, {
                        componentType: "Statistic",
                        cellColor: "background_accent"
                    }, {
                        componentType: "RadialBar",
                        cellColor: "background_accent"
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "dashboard",
        icon: "dashboard",
        title: "Dashboard",
        description: "Graph trends over time. Emphasize key changes and call out important data.",
        category: "data popular",
        tags: "dashboard statistics grid info financial column traction data chart growth projections data series line time trend compete competitors competitor competition grew shrunk change changed changing grown revenue metrics performance business profit sales income volume expenses costs progress better worse faster slower more less higher lower amount total sum number time over churn retention compare vs comparison relationship financial model",
        relatedTemplates: ["chart_line", "chart_area", "chart_column", "chart_bar", "chart_waterfall", "chart_pie", "radial_bar_chart", "table"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",
        variations: "tabular",

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                items: [
                    {
                        componentType: "Chart",
                        childElement: {
                            ...getDefaultChartModel("line")
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "chart_line",
        icon: "chart_line",
        title: "Line Chart",
        description: "Graph trends over time. Emphasize key changes and call out important data.",
        category: "data popular",
        tags: "column traction data chart growth projections data series line time trend compete competitors competitor competition grew shrunk change changed changing grown revenue metrics performance business profit sales income volume expenses costs progress better worse faster slower more less higher lower amount total sum number time over churn retention compare vs comparison relationship financial model",
        relatedTemplates: ["chart_area", "chart_column", "chart_bar", "chart_waterfall", "chart_pie", "radial_bar_chart"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",
        variations: "tabular",

        defaultImageTrayType: TrayType.RIGHT_TRAY,

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                items: [
                    {
                        componentType: "Chart",
                        childElement: {
                            ...getDefaultChartModel("column")
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "chart_column",
        icon: "chart_column",
        title: "Column Chart",
        description: "Compare categories, track changes over time, or show parts of a whole.",
        category: "data",
        tags: "line pie chart donut chart burn traction market share bar chart time trend compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results percent percentage revenue metrics performance profit sales income volume expenses costs progress better worse faster slower better worse faster slower more less higher lower amount total sum part number share over time by category churn retention financial model compare comparison relationship",
        relatedTemplates: ["chart_bar", "chart_line", "chart_area", "chart_waterfall", "chart_pie", "compare_horizontal_bars", "compare_vertical_bars", "compare_radial_bars", "compare_vertical_pictograph", "slicechart", "compare_circles", "radial_bar_chart"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",
        variations: "tabular",

        defaultImageTrayType: TrayType.RIGHT_TRAY,

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                items: [
                    {
                        componentType: "Chart",
                        childElement: {
                            ...getDefaultChartModel("bar")
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "chart_bar",
        icon: "chart_bar",
        title: "Bar Chart",
        description: "Compare categories, track changes over time, or show parts of a whole.",
        category: "data",
        tags: "line pie chart donut chart burn traction market share bar chart time trend compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results percent percentage revenue metrics performance profit sales income volume expenses costs progress better worse faster slower better worse faster slower more less higher lower amount total sum part number share over time by category churn retention financial model compare comparison relationship",
        relatedTemplates: ["chart_column", "chart_line", "chart_area", "chart_waterfall", "chart_pie", "compare_horizontal_bars", "compare_vertical_bars", "compare_radial_bars", "compare_vertical_pictograph", "slicechart", "compare_circles", "radial_bar_chart"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",
        variations: "tabular",

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                items: [
                    {
                        componentType: "Chart",
                        childElement: {
                            ...getDefaultWaterfallChartModel()
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "chart_waterfall",
        icon: "chart_waterfall",
        title: "Waterfall Chart",
        description: "Communicate the cumulative effect of sequentially introduced positive or negative values.",
        category: "data",
        tags: "waterfall line pie chart donut chart burn traction market share bar chart time trend compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results percent percentage revenue metrics performance profit sales income volume expenses costs progress better worse faster slower better worse faster slower more less higher lower amount total sum part number share over time by category churn retention financial model compare comparison relationship",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",
        variations: "tabular",

        defaultImageTrayType: TrayType.RIGHT_TRAY,

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                items: [
                    {
                        componentType: "Chart",
                        childElement: {
                            ...getDefaultChartModel("area")
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "chart_area",
        icon: "chart_area",
        title: "Area Chart",
        description: "Show a volume change over time and emphasize key moments.",
        category: "data",
        tags: "column burn traction financial chart compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller revenue metrics performance business profit sales income volume expenses costs progress amount total sum number time over churn retention trend stacked",
        relatedTemplates: ["chart_line", "chart_column", "chart_bar", "chart_waterfall", "chart_pie", "radial_bar_chart"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",
        variations: "tabular",

        defaultImageTrayType: TrayType.RIGHT_TRAY,

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                items: [
                    {
                        componentType: "PieChart",
                        childElement: {
                            ...getDefaultPieChartModel()
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "chart_pie",
        icon: "chart_pie",
        title: "Pie Chart",
        description: "Communicate the distribution of data. Most meaningful when paired with absolute values.",
        category: "data",
        tags: "column donut chart category chart compete competitors competitor competition survey poll results business percent percentage better worse faster slower better worse faster slower more less higher lower total sum part number share market share compare vs comparison relationship results business size",
        relatedTemplates: ["compare_horizontal_bars", "compare_vertical_bars", "compare_radial_bars", "compare_vertical_pictograph", "slicechart", "compare_circles", "radial_bar_chart", "chart_area", "chart_line", "chart_column", "chart_bar"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "GanttChart",

        defaultData: {
            primary: {
                showGrid: true,
                showTaskDetail: "duration",
                items: [
                    {
                        startDate: Date.UTC(new Date().getFullYear(), 0, 1),
                        endDate: Date.UTC(new Date().getFullYear(), 0, 31, 23, 59, 59, 999),
                        label: ""
                    }
                ],
                isNormalized: true,
                milestones: []
            }
        },

        allowColorfulBackrounds: false,

    }), getStaticProps: () => ({
        id: "gantt_chart",
        icon: "gantt_chart",
        title: "Gantt Chart",
        description: "Depict hierarchy, sequence, and duration with relative or absolute timeframes.",
        category: "data",
        tags: "time task date end start process management people dependency schedule duration activity project status plan planning timeline coordinate track progress month quarter week year manager parallel dependencies",
        relatedTemplates: ["timeline", "horizontal-task-list", "kanban"],
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// COMPARE TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "CompareBubble",
        variations: "compare",

        allowColorful: true,

        defaultData: {
            "primary": {
                "minValue": 0,
                "maxValue": 100,
                "scaling": "linear",
                "items": [
                    {
                        "value": 10,
                        "title": ""
                    },
                    {
                        "value": 100,
                        "title": ""
                    },
                    {
                        "value": 50,
                        "title": ""
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "compare_circles",
        icon: "compare_circles",
        title: "Compare Circles",
        description: "Distinguish between the volume or outcome of two or more competing items.",
        category: "comparisons",
        tags: "line column emtric pie chart donut chart burn price pricing goal OKR compare vs ratio size market change time category categories bubble bubbles circle circles difference different unique compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results business percent percentage revenue metrics business profit sales business income volume expenses costs progress better worse faster slower more less higher lower over time market share churn retention make a head-to-head comparison relationship stat statistic infographic",
        relatedTemplates: ["compare_vertical_bars", "compare_horizontal_bars", "compare_radial_bars", "compare_vertical_pictograph", "slicechart", "radial_bar_chart", "chart_column", "chart_bar", "chart_pie"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "CompareRadialBar",
        variations: "compare",

        allowColorful: true,

        defaultData: {
            "primary": {
                "minValue": 0,
                "maxValue": 100,
                "scaling": "linear",
                "items": [
                    {
                        "value": 25,
                    },
                    {
                        "value": 75,
                    },
                    {
                        "value": 100,
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "compare_radial_bars",
        icon: "compare_radial_bars",
        title: "Compare Radial Bars",
        description: "Compare progress or outcomes across items with a shared objective.",
        category: "comparisons",
        tags: "column pie chart donut chart goal OKR chart compare vs infographic change compete competitors competitor competition grow growing data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown poll business percent percentage progress better worse faster slower more less higher lower metrics performance business performance business over time churn retention make a head-to-head comparison relationship market share stat statistic growth projections categories infographic",
        relatedTemplates: ["compare_vertical_bars", "compare_horizontal_bars", "compare_circles", "compare_vertical_pictograph", "slicechart", "radial_bar_chart", "chart_column", "chart_bar", "chart_pie"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "CompareVerticalBar",

        variations: "compare",

        allowColorful: true,

        defaultData: {
            "primary": {
                "minValue": 0,
                "maxValue": 100,
                "scaling": "linear",
                "items": [
                    {
                        "value": 25,
                        "title": ""
                    },
                    {
                        "value": 75,
                        "title": ""
                    },
                    {
                        "value": 100,
                        "title": ""
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "compare_vertical_bars",
        icon: "compare_vertical_bars",
        title: "Compare Columns",
        description: "Distinguish between the volume or outcome of two or more competing items.",
        category: "comparisons",
        tags: "line pie chart donut chart price pricing goal OKR market share chart compare vs bar change category categories difference different unique compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results business revenue metrics business business profit sales income volume expenses costs progress better worse faster slower more less higher lower over churn retention make a head-to-head comparison relationship stat statistic size infographic",
        relatedTemplates: ["compare_radial_bars", "compare_horizontal_bars", "compare_circles", "compare_vertical_pictograph", "slicechart", "radial_bar_chart", "chart_column", "chart_bar", "chart_pie"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "CompareHorizontalBar",

        variations: "compare",

        allowColorful: true,

        defaultData: {
            "primary": {
                "minValue": 0,
                "maxValue": 100,
                "scaling": "linear",
                "items": [
                    {
                        "value": 25,
                    },
                    {
                        "value": 75,
                    },
                    {
                        "value": 100,
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "compare_horizontal_bars",
        icon: "compare_horizontal_bars",
        title: "Compare Bars",
        description: "Distinguish between the volume or outcome of two or more competing items.",
        category: "comparisons",
        tags: "line pie chart donut chart price pricing goal OKR market share chart compare vs bar change time category categories difference different unique compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results business revenue metrics business business profit sales income volume expenses costs progress better worse faster slower more less higher lower over churn retention make a head-to-head comparison relationship stat statistic size infographic",
        relatedTemplates: ["compare_radial_bars", "compare_vertical_bars", "compare_circles", "compare_vertical_pictograph", "slicechart", "radial_bar_chart", "chart_column", "chart_bar", "chart_pie"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "CompareVerticalPictograph",

        variations: "compare",

        allowColorful: true,

        defaultData: {
            "primary": {
                "minValue": 0,
                "maxValue": 100,
                "scaling": "linear",
                "showValue": true,
                "items": [
                    {
                        "value": 50,
                    },
                    {
                        "value": 75,
                    },
                    {
                        "value": 100,
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "compare_vertical_pictograph",
        icon: "compare_vertical_pictograph",
        title: "Percentage Comparison",
        description: "Distinguish between the progress toward a shared goal of two or more competing items.",
        category: "comparisons",
        tags: "column pie chart donut chart goal OKR compare vs change time icons categories difference different unique compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown survey poll results business progress better worse faster slower more less higher lower churn retention make a head-to-head comparison relationship data over time stat statistic infographic",
        relatedTemplates: ["compare_radial_bars", "compare_vertical_bars", "compare_circles", "compare_horizontal_bars", "slicechart", "radial_bar_chart", "chart_column", "chart_bar", "chart_pie", "visual_percentage"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "SliceChart",
        variations: "compare",

        allowColorBackgrounds: true,
        allowColorful: true,
        defaultData: {
            "primary": {
                "items": [
                    {
                        "width": 1
                    },
                    {
                        "width": 1
                    },
                    {
                        "width": 2
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "slicechart",
        icon: "slicechart",
        title: "Compare Slices",
        description: "Show the relative relationship between the parts of a whole.",
        category: "comparisons",
        tags: "compete competitors competitor competition partner partners user users targets pipeline case study landscape infographic",
        relatedTemplates: ["compare_radial_bars", "compare_vertical_bars", "compare_horizontal_bars", "compare_circles", "compare_vertical_pictograph", "radial_bar_chart", "chart_column", "chart_bar", "chart_pie"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ProcessDiagramChevrons",
        variations: "process",

        allowColorful: true,
        defaultData: {
            "primary": {
                "backgroundColor": "theme",
                "gradiateColors": true,
                "items": [{}, {}, {}],
            }
        }
    }), getStaticProps: () => ({
        id: "step_chevrons",
        icon: "step_chevrons",
        title: "Process Diagram",
        description: "Show the sequence of steps that contribute to an objective.",
        category: "diagram",
        tags: "pipeline procedure schedule lifecycle protocol sequence event evolution objective goal OKR OKR process diagram flow chevron chevrons steps step agenda schedule timeline progress over time project schedule update infographic",
        relatedTemplates: ["sequence", "gears", "puzzle", "step_boxes", "timeline", "journey", "horizontal-task-list", "step_circular", "flow_chart"]
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ProcessDiagramBoxes",
        variations: "process",

        allowColorful: true,
        defaultData: {
            "primary": {
                "items": [{}, {}, {}],
            }
        }
    }), getStaticProps: () => ({
        id: "step_boxes",
        icon: "step_boxes",
        title: "Numbered Boxes",
        description: "Arrange concepts, steps, or tasks in sequential, contained boxes.",
        category: "diagram",
        tags: "pipeline procedure schedule lifecycle protocol sequence event evolution process objective goal OKR process flow diagram steps schedule agenda steps time timeline project schedule update number numbered objective goal OKR process diagram flow box message messages agenda compete competitors competitor competition values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions schedule accomplish accomplishments accomplished key takeaway highlight priority",
        relatedTemplates: ["step_chevrons", "sequence", "gears", "puzzle", "textlist", "textBoxGrid", "textgrid_vertical_icons", "textgrid_photos", "textgrid_carousel"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "IconCircle",
        variations: "nodes",

        allowColorful: true,
        defaultData: {
            primary: {
                ellipse_size: 1,
                show_arrows: true,
                clockwise: true,
                shape_is_polygon: false,
                items: [
                    {
                        content_type: "icon",
                        content_value: "",
                        nodeType: NodeType.CONTENT_AND_TEXT
                    },
                    {
                        content_type: "icon",
                        content_value: "",
                        nodeType: NodeType.CONTENT_AND_TEXT
                    },
                    {
                        content_type: "icon",
                        content_value: "",
                        nodeType: NodeType.CONTENT_AND_TEXT
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "step_circular",
        icon: "step_circular",
        title: "Cycle",
        description: "Represent a continuous process with no end point.",
        category: "diagram",
        tags: "procedure schedule wheel lifecycle protocol sequence event evolution process diagram flow circle circular round looping virtuous vicious circle cycle repeat repeating round around time network effects infographic",
        relatedTemplates: ["cycle_diagram", "flow_chart", "hub_and_spoke", "connection_diagram"]
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "HubAndSpoke",
        variations: "nodes",

        allowColorful: true,
        defaultData: {
            primary: {
                ellipse_size: 1.15,
                useAlternateRotation: true,
                items: [
                    {
                        nodeType: NodeType.CONTENT_AND_TEXT
                    },
                    {
                        nodeType: NodeType.CONTENT_AND_TEXT
                    },
                    {
                        nodeType: NodeType.CONTENT_AND_TEXT
                    },
                    {
                        nodeType: NodeType.CONTENT_AND_TEXT
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "hub_and_spoke",
        icon: "hub_and_spoke",
        title: "Hub and Spoke",
        description: "Illustrate divergence or convergence with a central core.",
        category: "diagram",
        tags: "network relationship connect connection hub spoke diagram universe solar system constellation molecule molecular tree planet circle bubble mindmap mind map brainstorm distribution distribute model structure organization org piece Components core universe center",
        relatedTemplates: ["step_circular", "cycle_diagram", "flow_chart", "connection_diagram"]
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "NodeDiagram",

        allowColorful: true,
        allowCallouts: false,
        defaultData: {
            primary: {
                snapToGrid: false,
                showGrid: false,
                elements: [
                    {
                        fitToText: true,
                        width: 200,
                        height: 50,
                        calloutType: CalloutType.BOX,
                        type: AuthoringElementType.CALLOUT,
                        x: 590,
                        y: 248
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "flow_chart",
        icon: "flow_chart",
        title: "Flow Chart",
        description: "Illustrate abstract concepts, decision points, and relationships with a multidirectional flow.",
        category: "diagram",
        tags: "flow diagram process decision path branch branching outline node network relationship connect connection hub spoke diagram mindmap mind map brainstorm distribution distribute model structure organization org",
        relatedTemplates: ["step_chevrons", "step_circular", "hub_and_spoke", "sequence", "gears", "puzzle"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Timeline",
        variations: "timeline",

        availableTrayLayouts: [],
        availableHeaderPositions: [HeaderPositionType.TOP],

        allowColorful: true,
        allowCallouts: true,

        defaultData: {
            primary: {
                fit: false,
                showContent: false,
                scale: 1,
                scroll: 0,
                showStartMarker: true,
                showEndMarker: true,
                startMarker: {
                    start_marker: { text: "Start" }
                },
                endMarker: {
                    end_marker: { text: "End" }
                },
                annotations: {
                    items: [
                        {
                            id: "448ac75a-79b3-4090-b374-437a2ad7069b",
                            nodeType: "text",
                            hasBeenDragged: false,
                            x: 0.25,
                            y: 0.25,
                            hideNodeConnectorWidget: true,
                            textDirection: "right",
                            textWidth: null,
                            text: {
                                blocks: [
                                    {
                                        html: "",
                                        type: "text",
                                        textStyle: "title"
                                    }
                                ]
                            }
                        },
                        {
                            id: "35ecd892-4d4d-4f3c-8840-cce4dc2935cb",
                            nodeType: "text",
                            hasBeenDragged: false,
                            x: 0.5,
                            y: 0.75,
                            hideNodeConnectorWidget: true,
                            textDirection: "right",
                            textWidth: null,
                            text: {
                                blocks: [
                                    {
                                        html: "",
                                        type: "text",
                                        textStyle: "title"
                                    }
                                ]
                            }
                        },
                        {
                            id: "29a1bb63-26b0-4ab9-b301-4c243b55355c",
                            nodeType: "text",
                            hasBeenDragged: false,
                            x: 0.75,
                            y: 0.25,
                            hideNodeConnectorWidget: true,
                            textDirection: "right",
                            textWidth: null,
                            text: {
                                blocks: [
                                    {
                                        html: "",
                                        type: "text",
                                        textStyle: "title"
                                    }
                                ]
                            }
                        }
                    ],
                    connections: {
                        items: []
                    }
                }
            }
        }
    }), getStaticProps: () => ({
        id: "timeline",
        icon: "timeline",
        title: "Timeline",
        description: "Communicate the distribution and sequence of events within a defined period.",
        category: "diagram popular",
        tags: "status procedure schedule experience background personal education event traction objective goal OKR time timeline duration date milestone milestones agenda history past present future progress accomplish accomplishments accomplished case study over time process",
        relatedTemplates: ["journey", "gantt_chart", "step_chevrons", "sequence", "gears", "puzzle"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "CycleDiagram",
        variations: "nodes",

        availableHeaderPositions: [HeaderPositionType.TOP],
        availableTrayLayouts: [],

        allowColorful: true,
        defaultData: {
            primary: {
                collectionColor: "colorful",
                items: [{}, {}, {}, {}],
            }
        }
    }), getStaticProps: () => ({
        id: "cycle_diagram",
        icon: "cycle_arrow_2",
        title: "Arrow Cycle",
        description: "Represent a continuous process with no end point.",
        category: "diagram",
        tags: "procedure schedule wheel lifecycle protocol sequence event evolution process diagram flow circle circular round looping virtuous vicious circle cycle repeat repeating round around time network effects infographic",
        relatedTemplates: ["step_circular", "flow_chart", "hub_and_spoke", "connection_diagram"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ConnectionDiagram",
        variations: "nodes",

        availableHeaderPositions: [HeaderPositionType.TOP],
        availableTrayLayouts: [],

        allowColorful: true,
        defaultData: {
            primary: {
                style: "many-to-many",
                show3DEffect: true,
                showHeaders: false,
                column1: {
                    collectionColor: "theme-to-dark",
                    decorationStyle: DecorationStyle.FILLED,
                    items: [{}, {}, {}]
                },
                column2: {
                    collectionColor: "theme-to-dark",
                    decorationStyle: DecorationStyle.FILLED,
                    items: [{}, {}, {}]
                },
                target: {
                    frameType: "circle",
                    text: {
                        blocks: [{}]
                    }
                }
            }
        }
    }), getStaticProps: () => ({
        id: "connection_diagram",
        icon: "connection_diagram",
        title: "Connection Diagram",
        description: "Represent a continuous process with no end point.",
        category: "diagram",
        tags: "connect compare relationship network connection before after target",
        relatedTemplates: ["step_circular", "flow_chart", "hub_and_spoke"],
        hideTemplate: false
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ROICalculator",
        defaultData: {
            primary: {
                inputs: [{
                    name: "users",
                    label: "Number of Users",
                    min: 0, max: 2000, step: 1, format: FormatType.NUMBER, value: 50
                }, {
                    name: "hourly_cost",
                    label: "Hourly Cost",
                    min: 0, max: 300, step: 1, format: FormatType.CURRENCY, value: 75
                }, {
                    name: "hours_spent",
                    label: "Hours Spent per Week",
                    min: 0, max: 50, step: 1, format: FormatType.NUMBER, value: 5
                }, {
                    name: "savings",
                    label: "Percent of Time Saved",
                    min: 0, max: 100, step: 1, format: FormatType.PERCENT, value: .25
                }],
                calculations: [{
                    label: "Savings per Month",
                    formula: "users * hourly_cost * hours_spent * 4 * savings",
                    format: FormatType.CURRENCY,
                    text: "/month"
                }, {
                    label: "Savings per Year",
                    formula: "users * hourly_cost * hours_spent * 52 * savings",
                    format: FormatType.CURRENCY,
                    text: "/year"
                }],
            }
        }
    }), getStaticProps: () => ({
        id: "roi_calculator",
        icon: "roi",
        title: "ROI Calculator",
        category: "data",
        tags: "roi calculator investment dynamic",
        hideTemplate: false
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Boxes",

        allowColorful: true,
        defaultData: {
            primary: {
                items: [{}, {}, {}]
            }
        }
    }), getStaticProps: () => ({
        id: "boxes",
        icon: "boxes_numbered",
        title: "Boxes",
        category: "basic popular",
        tags: "box",
        hideTemplate: true
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Timeline2",

        availableTrayLayouts: [],
        availableHeaderPositions: [HeaderPositionType.TOP],

        allowColorful: true,

        variations: "timeline",

        defaultData: {
            primary: {}
        }
    }), getStaticProps: () => ({
        id: "timeline2",
        icon: "timeline",
        title: "Timeline 2",
        description: "Communicate the distribution and sequence of events within a defined period.",
        category: "diagram popular",
        tags: "status procedure schedule experience background personal education event traction objective goal OKR time timeline duration date milestone milestones agenda history past present future progress accomplish accomplishments accomplished case study over time process",
        relatedTemplates: ["journey", "gantt_chart", "step_chevrons"],
        hideTemplate: true
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Journey",
        variations: "timeline",

        availableTrayLayouts: [],
        availableHeaderPositions: [HeaderPositionType.TOP],
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,
        allowColorful: true,

        defaultData: {
            primary: {
                fit: false,
                scale: 1,
                scroll: 0,
                showStartMarker: false,
                showEndMarker: false,
                startMarker: {
                    start_marker: null,
                },
                endMarker: {
                    end_marker: null,
                },
                items: [{}, {}, {}],
            }
        }
    }), getStaticProps: () => ({
        id: "journey",
        icon: "journey",
        title: "Journey",
        description: "Communicate the sequence of events over an abstract period of time.",
        category: "diagram",
        tags: "status procedure schedule experience background personal education event traction objective goal OKR time timeline duration date milestone milestones agenda history past present future progress accomplish accomplishments accomplished case study over time process path journey road trail meander",
        relatedTemplates: ["timeline", "step_chevrons"],
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// PEOPLE TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "ContactInfo",
        version: 8,

        allowHeader: false,
        allowElementTextInline: false,
        allowElementTextTray: false,
        allowElementAttribution: false,
        allowFooter: true,
        preventDefaultFooter: true,

        availableTrayLayouts: [],

        defaultBackgroundStyle: "backgroundDark",
        allowColorful: true,

        defaultData: {
            primary: {
                layout: "left_map",
                map_address: {
                    blocks: [{
                        html: DEFAULT_ADDRESS,
                        hyphenation: false,
                        id: "map_address",
                        ligatures: false,
                        textStyle: "title",
                        type: "text"
                    }]
                },
                showMarker: true,
                items: [
                    {
                        type: "contact_header",
                        text: "Contact Us"
                    },
                    {
                        type: "address",
                    },
                    {
                        type: "phone",
                        content_value: ""
                    },
                    {
                        type: "social",
                        social_type: "twitter",
                        content_value: ""
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "contactus",
        icon: "contact_info",
        title: "Contact Info",
        description: "Let people know where to find you and how to get in touch.",
        category: "organization",
        tags: "map place location office org organization contact address location phone email twitter instagram linkedin facebook company business team about us share my contact info",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "TextSlide",

        showHeader: true,
        allowColorful: true,

        defaultData: {
            layout: {
                trayLayout: TrayType.LEFT_TRAY,
            },
            tray: {
                trayWidth: 567,
                items: [{}]
            }
        }
    }), getStaticProps: () => ({
        id: "long_bio",
        icon: "long_bio",
        title: "Long Bio",
        description: "A free space to write a longer biography of yourself.",
        category: "people",
        tags: "speaker about me experience background personal education person bio contact speaker presenter about me phone email twitter instagram linkedin facebook photo photos photographs images pictures portrait headshot share my contact info intros team",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "LogoGrid",
        variations: "list",

        availableTrayLayouts: [],

        allowColorful: false,

        defaultData: {
            primary: {
                showFrame: true,
                showBackdrop: true,
                defaultLogoScale: 0.8,
                items: [
                    {
                        content_type: "logo",
                        content_value: ""
                    },
                    {
                        content_type: "logo",
                        content_value: ""
                    },
                    {
                        content_type: "logo",
                        content_value: ""
                    },
                    {
                        content_type: "logo",
                        content_value: ""
                    },
                    {
                        content_type: "logo",
                        content_value: ""
                    },
                    {
                        content_type: "logo",
                        content_value: ""
                    }
                ]
            }
        }

    }), getStaticProps: () => ({
        id: "logogrid",
        icon: "logogrid",
        title: "Logo Grid",
        description: "Reflect a customer or partner ecosystem by putting their logos on display.",
        category: "product",
        tags: "status pipeline press pr partners partnerships logo logos marketing sales customer customers compete competitors competitor competition partner partners user users targets pipeline case study landscape",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Team",
        allowColorful: false,

        defaultData: {
            "primary": {
                "items": [
                    {
                        "content_type": "image",
                        "content_value": ""
                    },
                    {
                        "content_type": "image",
                        "content_value": ""
                    },
                    {
                        "content_type": "image",
                        "content_value": ""
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        id: "team",
        icon: "team",
        title: "Team Members",
        description: "Introduce yourself or key team members to your audience.",
        category: "people popular",
        tags: "team photos company business presenter presenters lineup speaker speakers org organization company business people teammates employees headshot photo photos photographs images pictures portrait list intros org structure bios",
        relatedTemplates: ["orgchart"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "OrgChart",

        defaultData: {
            primary: {
                defaultNodeStyle: "box",
                hideRootNode: false,
                layout: "expanded",
                layoutDirection: "vertical",
                items: [{
                    id: "0",
                    index: 0,
                    nodeType: "person",
                }, {
                    id: "1",
                    index: 0,
                    nodeType: "person",
                    parent: "0",
                }, {
                    id: "2",
                    index: 1,
                    nodeType: "person",
                    parent: "0",
                }, {
                    id: "3",
                    index: 0,
                    nodeType: "person",
                    parent: "2",
                }, {
                    id: "4",
                    index: 1,
                    nodeType: "person",
                    parent: "2",
                }]
            }
        }
    }), getStaticProps: () => ({
        id: "orgchart",
        icon: "org_chart",
        title: "Org Chart",
        description: "Visualize the structure of a team, company, or organization.",
        category: "people",
        tags: "org structure organization company business team people hierarchy",
        relatedTemplates: ["team"],
    })
});

// -----------------------------------------------------------------------------------------------------------------------------------------------------------------
// VIDEO TEMPLATES
// -----------------------------------------------------------------------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "Video",

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE,
                showFooter: "off",
            },
            primary: {
                fullBleed: true,
                autoPlay: true,
                startTime: 0
            }
        },

        allowHeader: true,
        allowFooter: true,

        canConvertToAuthoring: false,

        allowColorful: false,
    }), getStaticProps: () => ({
        id: "video",
        icon: "video",
        title: "Video",
        category: "impact",
        tags: "video movie clip mp4 mov",
        description: "Use video to reinforce your story.",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",
        variations: "tabular",

        defaultData: {
            primary: {
                items: [
                    {
                        componentType: "Table",
                        childElement: {
                            tableWidth: 1,
                            tableHeight: 1,
                            showTopLeftCell: true,
                            showColGridLines: true,
                            showRowGridLines: true,
                            showHeaderRow: true,
                            showHeaderCol: true,
                        }
                    }
                ]
            }
        }

    }), getStaticProps: () => ({
        id: "table-v2",
        icon: "table",
        title: "Table",
        description: "Organize your data into columns and rows to present information, categorize ideas, or compare items.",
        category: "basic popular",
        tags: "traction objective goal OKR market share feature features product benefit benefits business differentiate project differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions percent percentage revenue metrics business profit sales income volume expenses costs summary summarize accomplish accomplishments accomplished make a list amount total sum churn metrics financial model compare vs by categories results business update status relationship",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "SlidePlaceholder",

        allowHeader: false,
        allowFooter: false,
        allowLayouts: false,
        allowElementTextInline: false,
        allowElementTextTray: false,
        allowElementAttribution: false,

        availableTrayLayouts: [],

        canConvertToAuthoring: false,
    }), getStaticProps: () => ({
        id: "slidePlaceholder",
        icon: "placeholder",
        title: "Slide Placeholder",
        description: "Not sure which template to choose yet? Don't worry, we'll hold your spot.",
        category: "organization",
        tags: "place placeholder tbd scratch pad scratchpad blank slide",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "StackDiagram",
        // variations: "stackdiagram",

        allowColorBackgrounds: true,
        allowColorful: false,

        defaultData: {
            primary: {}
        }
    }), getStaticProps: () => ({
        id: "stackDiagram",
        icon: "stack_hierarchy",
        title: "Stack Diagram",
        description: "Communicate relationship, hierarchy, and distribution through stacked layers.",
        category: "diagram",
        tags: "stack structure organization order relationship software architecture services layer group flow diagram platform base system foundation box boxes",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "UserTestimonial",
        variations: "list",

        allowColorful: true,
        defaultData: {
            primary: {
                showTail: true,
                showDesignQuotes: true,
                frameStyle: "quote-box",
                items: [
                    {
                        showAttribution: true,
                        showImage: true,
                        showLogo: false
                    },
                    {
                        showAttribution: true,
                        showImage: true,
                        showLogo: false
                    }
                ]
            }
        },
    }), getStaticProps: () => ({
        id: "user_testimonial",
        icon: "user_testimonial",
        title: "Quotes",
        description: "Use industry, customer, or leadership quotes to communicate ideas or feedback.",
        category: "people",
        tags: "users user testimonial persona partners partnerships pr press customers problem speaker intros team culture members compete competitors competitor competition messages message make a list items category categories reasons values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished photo photos photographs images pictures services solution key takeaway highlight priority bullet update status points case study landscape call to action image text product features",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Calendar",

        variations: "calendar",
        allowColorBackgrounds: true,

        defaultData: {
            primary: {
                showTitle: false,
                showWeekends: true,
                startOnMonday: false,
                calendarType: "month",
                date: moment().startOf("week").format("MM/DD/YYYY")
            }
        }

    }), getStaticProps: () => ({
        id: "calendar-month",
        icon: "calendar_month",
        title: "Calendar - Month",
        description: "Display temporal events or projects over a calendar month.",
        category: "diagram",
        tags: "calendar date week month time day days year tasks schedule events when",
        relatedTemplates: ["calendar-week", "kanban", "gantt_chart"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Calendar",

        variations: "calendar",
        allowColorBackgrounds: true,

        defaultData: {
            primary: {
                showTitle: false,
                showWeekends: true,
                startOnMonday: false,
                calendarType: "week",
                date: moment().startOf("week").format("MM/DD/YYYY")
            }
        }
    }), getStaticProps: () => ({
        id: "calendar-week",
        icon: "calendar_week",
        title: "Calendar - Week",
        description: "Display temporal events or projects over a calendar week.",
        category: "diagram",
        tags: "calendar date week month time day days year tasks schedule events when",
        relatedTemplates: ["calendar-month", "kanban", "gantt_chart"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "VerticalTaskLists",
        variations: "tasklist",

        allowColorBackgrounds: false,

        defaultData: {
            primary: {
                items: [{
                    label: "To do",
                    items: [{}, {
                        color: "accent1",
                        icon: "star"
                    }]
                }, {
                    label: "In progress",
                    items: [{}, {}]
                }, {
                    label: "Completed",
                    items: [{
                        color: "accent1",
                        icon: "star"
                    }]
                }]
            }
        }
    }), getStaticProps: () => ({
        id: "kanban",
        icon: "kanban",
        title: "Kanban Board",
        description: "Cluster lists into enclosed vertical containers to communicate tasks, progress, hierarchy, and responsibiliity.",
        category: "diagram",
        tags: "kanban project board cards columns tasks progress swimlane team work organize flow process",
        relatedTemplates: ["horizontal-task-list", "gantt_chart"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "HorizontalTaskLists",
        variations: "tasklist",

        allowColorBackgrounds: false,

        defaultData: {
            primary: {
                items: [{
                    label: "To do",
                    items: [{}, {}]
                }, {
                    label: "In progress",
                    items: [{}, {}]
                }, {
                    label: "Completed",
                    items: [{}]
                }]
            }
        }
    }), getStaticProps: () => ({
        id: "horizontal-task-list",
        icon: "horizontal-task-list",
        title: "Task List",
        description: "Cluster lists into enclosed horizontal containers to communicate tasks, progress, hierarchy, and responsibiliity.",
        category: "diagram",
        tags: "kanban project board cards columns tasks progress swimlane team work organize flow process",
        relatedTemplates: ["kanban", "gantt_chart"],
    })
});

//--------------------------------------------------------------------------------------------------
// Classic templates
//--------------------------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "AuthoringCanvas",

        allowLayouts: true,
        allowHeader: true,
        allowFooter: true,
        allowElementCaption: false,
        allowElementAttribution: false,
        allowElementTextInline: false,
        allowElementTextTray: false,

        allowAnnotations: false,

        availableTrayLayouts: [],

        allowColorBackgrounds: true,
        allowColorful: false,

        allowCallouts: false,
        canConvertToAuthoring: false,

        canSwitchTemplate: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {}
        }
    }), getStaticProps: () => ({
        id: "authoring",
        icon: "authoring",
        title: "Classic",
        description: "Start from scratch with a blank slide.",
        category: "basic",
        tags: "blank empty white canvas scratch",
        hideTemplate: false,
    })
});

/// HIDDEN TEMPLATES ------------------------------------------------------------------------------

templates.push({
    getInstanceProps: () => ({
        elementType: "TextList",

        showHeader: true,
        showFooter: false,
        allowElementAttribution: true,
        allowColorful: true,

        defaultData: {
            layout: {
                trayLayout: TrayType.LEFT_INLINE,
            },
            tray: {
                // trayElement: "Image",
                trayWidth: 470,
                items: [{}]
            },
            primary: {
                forceSingleColumn: true,
                items: [{}]
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "bullets_image",
        icon: "bullets_image",
        title: "List with an Image",
        description: "Pair your bullet points with an inline image to give them equal weight.",
        category: "basic",
        tags: "bullet update status points text message messages values share our vision feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions summary summarize accomplish accomplishments accomplished make a list services solution key takeaway highlight priority case study product features"
    })
});
templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        availableTrayLayouts: [],

        allowElementAttribution: false,

        allowFooter: true,
        preventDefaultFooter: true,
        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
                showGutter: true,
                fullBleed: true,
                matchTextScale: true,
                items: [{}, {}],
                layoutType: "grid",
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "picture_picture",
        icon: "picture_picture",
        title: "Two Images",
        description: "Place two images side-by-side to make a comparison or a statement.",
        category: "impact",
        tags: "pro con picture image photo photos photographs images pictures emotional inspire audience inspiration emotion impact feelings compare vs comparison relationship"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        allowElementAttribution: false,

        availableTrayLayouts: [],

        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            primary: {
                showGutter: true,
                fullBleed: false,
                matchTextScale: true,
                items: [
                    {
                        x: 0,
                        y: 0,
                        width: 3,
                        height: 4,
                    },
                    {
                        x: 3,
                        y: 0,
                        width: 3,
                        height: 2,
                    },
                    {
                        x: 3,
                        y: 2,
                        width: 3,
                        height: 2,
                    }
                ],
                cols: 6,
                rows: 4
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "imagegrid",
        icon: "imagegrid",
        title: "Image Grid with Header",
        description: "Place images and headline text in a flexible and customizable grid.",
        category: "basic",
        tags: ""
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        availableTrayLayouts: [],

        allowFooter: true,
        preventDefaultFooter: true,
        allowHeader: false,
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,

        defaultData: {
            primary: {
                blocks: [{
                    type: AuthoringBlockType.TEXT,
                }],
                items: [],
                layoutType: "grid",
                fullBleed: true,
                showGutter: true
            }
        },
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "headline",
        icon: "headline",
        title: "Headline",
        description: "Bold text placed over a beautiful image. Just like your favorite Nike ad.",
        category: "impact popular",
        tags: "thank big segue transition share our mission provocative question call to action vision differentiate differentiator proposition propositions powerful bold summary summarize message statement accomplish accomplishments accomplished photo photos photographs images pictures emotional inspire audience inspiration emotion impact feelings key takeaway highlight big headline and culture text",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        availableTrayLayouts: [],

        allowFooter: true,
        preventDefaultFooter: true,
        allowHeader: false,
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,

        defaultData: {
            primary: {
                blocks: [
                    {
                        type: "label",
                        content: {
                            text: "Section 1",
                            styles: [
                                {
                                    start: 0,
                                    end: 9
                                }
                            ]
                        }
                    },
                    {
                        type: "headline"
                    }
                ],
                items: [],
                layoutType: "grid",
                fullBleed: true,
                showGutter: true
            },
            layout: {
                backgroundColor: "theme",
                backgroundStyle: "backgroundColor"
            }
        },

        version: 2,
    }), getStaticProps: () => ({
        id: "chapter",
        hideTemplate: true,
        icon: "section_break",
        title: "Section Break",
        description: "Moving on to another section of your presentation? Let your audience know.",
        category: "organization",
        tags: "question introduction introduce chapter section transition segue transition header",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",
        version: 2,

        allowHeader: false,
        allowFooter: true,
        preventDefaultFooter: true,
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,

        defaultBackgroundStyle: "backgroundLight",
        allowColorful: true,

        defaultData: {
            layout: {},
            primary: {
                items: [
                    {
                        cellColor: "theme"
                    },
                    {
                        cellColor: "theme",
                        showText: true,
                        blocks: [
                            {
                                type: "headline"
                            }
                        ]
                    }
                ],
                dividerSize: 0.5,
                aspectRatio: "fill",
                showGutter: true,
                layoutType: "grid",
                frame: "none",
                fullBleed: true
            }
        }

    }), getStaticProps: () => ({
        id: "picture_headline_right",
        hideTemplate: true,
        icon: "picture_headline_right",
        title: "Big Message with an Image",
        description: "A powerful image and message placed side-by-side. A presentation classic.",
        category: "impact",
        tags: "experience background personal education person thank logo problem big headline share our mission provocative question call to action vision differentiate differentiator proposition propositions powerful bold summary summarize statement accomplish accomplishments accomplished photo photos photographs images pictures message services solution emotional inspire audience inspiration emotion impact feelings big text"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        allowElementTitle: true,
        allowAttribution: false,

        availableTrayLayouts: [],

        allowFooter: true,
        preventDefaultFooter: true,
        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
                showGutter: true,
                fullBleed: true,
                items: [{
                    showText: true,
                    blocks: [{ type: "headline" }]
                }, {
                    showText: true,
                    blocks: [{ type: "headline" }]
                }]
            }
        },

    }), getStaticProps: () => ({
        id: "text_text",
        hideTemplate: true,
        icon: "text_text",
        title: "Two Messages",
        description: "Place two headlines side-by-side to create space between messages.",
        category: "impact",
        tags: "pro con emotional inspire audience inspiration emotion impact feelings compare vs comparison relationship two messages key headlines"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "PhotoCollage",

        allowElementAttribution: false,

        availableTrayLayouts: [],

        allowFooter: true,
        preventDefaultFooter: true,
        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
                showHeadline: false,
                showImages: true,
                layoutType: "grid",
                aspectRatio: "fill",
                showGutter: true,
                fullBleed: true,
                matchTextScale: true,
                items: [
                    {
                        cellColor: "theme",
                        showText: true,
                        blocks: [
                            {
                                type: "headline",
                            }
                        ]
                    },
                    {
                        cellColor: "theme"
                    },
                    {
                        cellColor: "theme"
                    },
                    {
                        cellColor: "theme"
                    },
                    {
                        cellColor: "theme"
                    }
                ],
                "cols": 4,
                "rows": 2,
                "gridLayout": "7"
            }
        }

    }), getStaticProps: () => ({
        id: "culturegrid",
        hideTemplate: true,
        icon: "culture_grid",
        title: "About Us",
        description: "Briefly describe your organization and show your team in action.",
        category: "people",
        tags: "about us org team culture share our mission vision company business organization values vision photo photos photographs images pictures collage emotional inspire audience inspiration emotion impact feelings teammate bio"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Headline",

        allowHeader: false,
        allowFooter: true,
        preventDefaultFooter: true,
        allowElementTextInline: true,
        allowElementTextTray: true,
        allowElementAttribution: true,

        availableTrayLayouts: [],

        defaultBackgroundStyle: "backgroundLight",
        allowColorful: true,

        defaultData: {
            layout: {},
            primary: {
                blocks: [{ type: "headline" }],
                items: [{}],
                dividerSize: 0.5,
                aspectRatio: "fill",
                showGutter: false,
                layoutType: "grid",
                frame: "none",
                fullBleed: false,
                headlinePosition: "left"
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "headline_image",
        icon: "headline_with_image",
        title: "Headline and image",
        description: "A powerful image and message placed side-by-side. A presentation classic.",
        category: "impact",
        tags: "experience background personal education person thank logo problem big headline share our mission provocative question call to action vision differentiate differentiator proposition propositions powerful bold summary summarize statement accomplish accomplishments accomplished photo photos photographs images pictures message services solution emotional inspire audience inspiration emotion impact feelings big text",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Headline",

        allowElementAttribution: false,

        availableTrayLayouts: [],

        allowFooter: true,
        preventDefaultFooter: true,
        allowColorful: true,
        allowColorBackgrounds: false,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
            primary: {
                aspectRatio: "fill",
                fullBleed: true,
                gridLayout: "0",
                headlinePosition: "left",
                items: [{}, {}, {}, {}],
                showGutter: true,
                showImages: true
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "aboutUs",
        icon: "culture_grid",
        title: "About Us",
        description: "Briefly describe your organization and show your team in action.",
        category: "people",
        tags: "about us org team culture share our mission vision company business organization values vision photo photos photographs images pictures collage emotional inspire audience inspiration emotion impact feelings teammate bio",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ProductScreenshot",
        defaultData: {
            "primary": {
                "listStyle": "bullets",
                "items": [
                    {
                        "isMedia": true,
                        "frameType": "iphone_x",
                        "aoiLeft": 0,
                        "aoiRight": 0,
                        "aoiTop": 0,
                        "aoiBottom": 0,
                        "scale": null,
                        "version": 1
                    },
                    {
                        "isMedia": false,
                        "text": {
                            "blocks": [
                                {
                                    "type": "text",
                                    "textStyle": "bulleted",
                                    "listStyle": "bullets",
                                    "html": "",
                                    "indent": 0
                                }
                            ]
                        },
                    }
                ],
                "autoArrangeColumnsCount": 2,
                "showColumnHeaders": false,
                "startNum": 1
            }
        },

        availableTrayLayouts: [],
        allowColorful: true,

    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "product_mobile",
        icon: "product_mobile",
        title: "Mobile Screenshot",
        description: "Call out product features on just about any device\u2014we've got 'em all.",
        category: "product",
        tags: "display product laptop desktop screenshot callouts features monitor screen shots pc device callout features mobile phone iphone android device mac feature features benefit benefits annotation differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions photo photos photographs images pictures demo"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ProductScreenshot",
        defaultData: {
            "primary": {
                "listStyle": "bullets",
                "items": [
                    {
                        "isMedia": true,
                        "text": null,
                        "frameType": "apple_thunderbolt_display",
                        "aoiLeft": 0,
                        "aoiRight": 0,
                        "aoiTop": 0,
                        "aoiBottom": 0,
                        "scale": null,
                        "version": 1
                    },
                    {
                        "isMedia": false,
                        "text": {
                            "blocks": [
                                {
                                    "type": "text",
                                    "textStyle": "bulleted",
                                    "listStyle": "bullets",
                                    "html": "",
                                    "indent": 0
                                }
                            ]
                        },
                    }
                ],
                "autoArrangeColumnsCount": 2,
                "showColumnHeaders": false,
                "startNum": 1
            }
        },

        availableTrayLayouts: [],

        allowColorful: true,

    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "product_desktop",
        icon: "product_desktop",
        title: "Desktop Screenshot",
        description: "Call out product features on just about any device\u2014we've got 'em all.",
        category: "product",
        tags: "product laptop desktop screenshot callouts features monitor screen shots pc device callout features mobile phone iphone android device mac feature features benefit benefits annotation differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions photo photos photographs images pictures demo"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "XYGraph",
        variations: "xygraph",

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                yAxisLabel: "Size",
                xAxisLabel: "Complexity",
                showArrowHeads: false,
                showAxis: false,
                showAxisLabels: false,
                showQuadrants: true,
                showQuadrantLabels: true,
                showGrid: true,
                gridSize: 34,
                label1: "Challengers",
                label2: "Leaders",
                label3: "Niche Players",
                label4: "Visionaries",
                items: [
                    {
                        x: 0.5,
                        y: 0.5,
                        size: 150,
                        color: "theme",
                        nodeType: NodeType.CIRCLE
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "quadrant",
        icon: "xy_quadrant",
        title: "Quadrants",
        description: "Group items into quadrants to give your audience a lay of the land.",
        category: "comparisons",
        tags: "persona competitive landscape venn xy pro con size group circles bubbles hierarchy set plot scatter scatterplot dimension quadrant axis axes cluster relationship market compare groups us vs them advantages comparison competition competitor relative more less same better worse big small attributes qualities scattergram"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "XYGraph",
        variations: "xygraph",

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            primary: {
                yAxisLabel: "Size",
                xAxisLabel: "Complexity",
                showArrowHeads: false,
                showAxis: false,
                showAxisLabels: false,
                showQuadrants: false,
                showQuadrantLabels: false,
                showGrid: false,
                gridSize: 34,
                label1: "Challengers",
                label2: "Leaders",
                label3: "Niche Players",
                label4: "Visionaries",
                items: [
                    {
                        x: 0.5,
                        y: 0.5,
                        size: 150,
                        color: "theme",
                        nodeType: NodeType.CIRCLE
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "bubbles",
        icon: "bubbles",
        title: "Floating Circles",
        description: "These free-floating circles are great for comparing items by size or location.",
        category: "comparisons",
        tags: "segment segmentation competitive landscape pie chart donut chart growth grow size circles bubbles scatter scatterplot cluster group relationship market compare groups us vs them advantages comparison competition competitor relative more less same better worse big small attributes qualities scattergram"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Pyramid",

        availableHeaderPositions: [HeaderPositionType.TOP],

        variations: "pyramid",

        allowColorful: true,
        defaultData: {
            "primary": {
                "inverted": false,
                "color": "accent1",
                "showDescription": true,
                capSize: 0,
                baseSize: 60,
                "items": [{}, {}, {}],
                "step": true
            }
        }

    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "pyramid_step",
        icon: "pyramid_step",
        title: "Step Pyramid",
        description: "A variation on the pyramid that can be used to build on a foundation.",
        category: "diagram",
        tags: "foundation pipeline price pricing market size pyramid hierarchy diagram message messages compete competitors competitor competition shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown values feature features benefit benefits differentiate differentiator differentiators characteristic characteristics attribute attributes qualities proposition propositions percent percentage landscape org structure"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",
        variations: "tabular",

        defaultImageTrayType: TrayType.RIGHT_TRAY,

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            "primary": {
                "items": [
                    {
                        "elementType": "chart",
                        "chart": {
                            "showLegend": false,
                            "showXAxis": true,
                            "showYAxis": true,
                            "showAxisLabels": false,
                            "showXGridLines": true,
                            "showYGridLines": true,
                            "groupData": false,
                            "chartData": {
                                "series": [
                                    {
                                        "id": "series1",
                                        "name": "Data",
                                        "type": "spline",
                                        "data": [
                                            {
                                                "y": 10,
                                            },
                                            {
                                                "y": 40,
                                            },
                                            {
                                                "y": 50,
                                            },
                                            {
                                                "y": 30,
                                            },
                                            {
                                                "y": 70,
                                            }
                                        ],
                                        "colorName": "chart1"
                                    }
                                ],
                                "xAxis": {
                                    "visible": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "categories": [
                                        "Jan",
                                        "Feb",
                                        "Mar",
                                        "Apr",
                                        "May"
                                    ],
                                    "showAxisLine": true,
                                    "showGridLine": false,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "axisTitle": false,
                                    "axisTitleText": "Title",
                                    "labelInterval": 1,
                                    "type": "linear",
                                    "autoType": "linear",
                                    "categoryType": "auto",
                                    "labels": {
                                        "enabled": true
                                    },
                                    zeroAxisPadding: true
                                },
                                "yAxis": {
                                    "visible": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "showAxisLine": true,
                                    "showGridLines": true,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "labelAbbreviation": false,
                                    "labelCurrency": "none",
                                    "labelFormat": "ones",
                                    "axisTitle": "none",
                                    "axisTitleText": "Title",
                                    "labels": {
                                        "enabled": true
                                    }
                                },
                                "yAxis2": {
                                    "visible": false,
                                    "opposite": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "showAxisLine": true,
                                    "showGridLines": true,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "labelAbbreviation": false,
                                    "labelCurrency": "none",
                                    "labelFormat": "ones",
                                    "axisTitle": "none",
                                    "axisTitleText": "Title",
                                    "labels": {
                                        "enabled": true
                                    }
                                },
                                "legend": {
                                    "enabled": false
                                }
                            },
                            "legendPosition": "off"
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "chart_spline",
        icon: "chart_spline",
        title: "Spline Chart",
        description: "These charts smooth out the lines between data points. Snazzy, right?",
        category: "data",
        tags: "column traction chart compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk change changed changing grown revenue metrics performance business profit sales income volume expenses costs progress better worse faster slower better worse faster slower more less higher lower amount total sum number time over churn retention trend",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",
        variations: "tabular",

        defaultImageTrayType: TrayType.RIGHT_TRAY,

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            "primary": {
                "items": [
                    {
                        "elementType": "chart",
                        "chart": {
                            "showLegend": false,
                            "showXAxis": true,
                            "showYAxis": true,
                            "showAxisLabels": false,
                            "showXGridLines": true,
                            "showYGridLines": true,
                            "groupData": false,
                            "chartData": {
                                "series": [
                                    {
                                        "id": "series1",
                                        "name": "Data",
                                        "type": "areaspline",
                                        "data": [
                                            {
                                                "y": 10,
                                            },
                                            {
                                                "y": 40,
                                            },
                                            {
                                                "y": 50,
                                            },
                                            {
                                                "y": 30,
                                            },
                                            {
                                                "y": 70,
                                            }
                                        ],
                                        "colorName": "chart1"
                                    }
                                ],
                                "xAxis": {
                                    "visible": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "categories": [
                                        "Jan",
                                        "Feb",
                                        "Mar",
                                        "Apr",
                                        "May"
                                    ],
                                    "showAxisLine": true,
                                    "showGridLine": false,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "axisTitle": false,
                                    "axisTitleText": "Title",
                                    "labelInterval": 1,
                                    "type": "linear",
                                    "autoType": "linear",
                                    "categoryType": "auto",
                                    "labels": {
                                        "enabled": true,
                                        "rotation": 0
                                    },
                                    zeroAxisPadding: true
                                },
                                "yAxis": {
                                    "visible": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "showAxisLine": true,
                                    "showGridLines": true,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "labelAbbreviation": false,
                                    "labelCurrency": "none",
                                    "labelFormat": "ones",
                                    "axisTitle": "none",
                                    "axisTitleText": "Title",
                                    "labels": {
                                        "enabled": true
                                    }
                                },
                                "yAxis2": {
                                    "visible": false,
                                    "opposite": true,
                                    "showFirstLabel": true,
                                    "showLastLabel": true,
                                    "endOnTick": true,
                                    "showAxisLine": true,
                                    "showGridLines": true,
                                    "showMajorTicks": false,
                                    "showMinorTicks": false,
                                    "labelAbbreviation": false,
                                    "labelCurrency": "none",
                                    "labelFormat": "ones",
                                    "axisTitle": "none",
                                    "axisTitleText": "Title",
                                    "labels": {
                                        "enabled": true
                                    }
                                },
                                "legend": {
                                    "enabled": false
                                }
                            },
                            "legendPosition": "off"
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "chart_area_spline",
        icon: "chart_area_spline",
        title: "Area Spline Chart",
        description: "An area chart with smooth lines. It's like beautiful, rolling hills of data.",
        category: "data",
        tags: "column curve traction chart compete competitors competitor competition grow growing growth projections data shrink shrinking shrink bigger big large larger small smaller grew shrunk grew shrunk change changed changing grown revenue metrics performance business profit sales income volume expenses costs progress amount total sum number time over churn retention trend stacked",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Dashboard",
        variations: "tabular",

        defaultImageTrayType: TrayType.RIGHT_TRAY,

        allowColorBackgrounds: false,
        allowColorful: true,

        defaultData: {
            "primary": {
                "items": [
                    {
                        "elementType": "piechart",
                        "piechart": {
                            "isDonut": true,
                            "startRadius": 0,
                            "innerRadius": 0,
                            "labelFormat": "percentage",
                            "sortValues": true,
                            "data": [
                                {
                                    "value": 3,
                                    "label": {
                                        "text": "Apple"
                                    },
                                    "color": "auto",
                                    "offset": 0
                                },
                                {
                                    "value": 2,
                                    "label": {
                                        "text": "Pear"
                                    },
                                    "color": "auto",
                                    "offset": 0
                                },
                                {
                                    "value": 5,
                                    "label": {
                                        "text": "Orange"
                                    },
                                    "color": "auto",
                                    "offset": 0
                                }
                            ]
                        }
                    }
                ]
            }
        }
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "chart_donut",
        icon: "chart_donut",
        title: "Donut Chart",
        description: "An alternative to pie charts that allows you to put a label in the center.",
        category: "data",
        tags: "column pie chart donut chart market size category chart compete competitors competitor competition survey poll results business percent percentage better worse faster slower better worse faster slower more less higher lower total sum chart number share market part of a whole compare vs comparison relationship results business",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ContactInfo",

        allowHeader: false,
        defaultBackgroundStyle: "backgroundDark",
        allowElementTextInline: false,
        allowElementTextTray: false,
        allowElementAttribution: false,

        availableTrayLayouts: [],

        allowColorful: true,

        defaultData: {
            "primary": {
                "layout": "left_picture",
                "items": [
                    {
                        "type": "contact_header",
                        "text": "Your Name"
                    },
                    {
                        "type": "text",
                        "text": "Your Title / Position / Company"
                    },
                    {
                        "type": "email",
                        "content_value": ""
                    },
                    {
                        "type": "phone",
                        "social_type": "twitter",
                        "content_value": ""
                    },
                    {
                        "type": "social",
                        "social_type": "twitter",
                        "content_value": ""
                    }
                ]
            }
        }

    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "business_card",
        icon: "business_card",
        title: "Business Card",
        description: "Show your audience who you are and how to reach you after the presentation.",
        category: "people",
        tags: "speaker about me experience background personal education person bio contact speaker presenter about me phone email twitter instagram linkedin facebook photo photos photographs images pictures portrait headshot share my contact info intros team"
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Video",

        allowHeader: true,
        allowFooter: true,
        allowColorful: false,
        canConvertToAuthoring: false,

        defaultData: {
            primary: {
                fullBleed: false,
                autoPlay: true,
                startTime: 0
            }
        },
    }), getStaticProps: () => ({
        hideTemplate: true,
        id: "video_title",
        icon: "video_title",
        title: "Video with Title",
        category: "impact",
        tags: "video movie clip mov mp4",
        isNew: true
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "WebView",

        canConvertToAuthoring: false,

        defaultData: {
            primary: {
                items: [{}]
            }
        }
    }), getStaticProps: () => ({
        id: "web-view",
        icon: "webview",
        title: "WebView",
        description: "Embed URLs for a product demo, your analytics dashboard or to display a live poll!",
        category: "impact",
        tags: "web page url embed iframe external website site http https",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ActionText",

        allowHeader: false,
        availableTrayLayouts: [],

        allowColorful: true,

        defaultData: {
            "primary": {}
        }
    }), getStaticProps: () => ({
        id: "action-text",
        icon: "action_text",
        title: "Action Text",
        description: "",
        category: "impact",
        tags: "",
        relatedTemplates: [],
        hideTemplate: true
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "ActionNumber",

        allowHeader: true,
        availableHeaderPositions: [HeaderPositionType.TOP],
        availableTrayLayouts: [],
        canConvertToAuthoring: false,
        canSwitchTemplate: false,

        allowColorful: true,

        defaultData: {
            layout: {
                headerPosition: HeaderPositionType.NONE
            },
        }
    }), getStaticProps: () => ({
        id: "action-number",
        icon: "action_number",
        title: "Action Number",
        description: "",
        category: "impact",
        tags: "statistic big number metric kpi key performance indicator data point animated stat",
        relatedTemplates: [],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "WorldMap",

        defaultData: {
            primary: {}
        }
    }), getStaticProps: () => ({
        id: "world_map",
        icon: "world-map",
        title: "World Map",
        category: "impact",
        tags: "map world country city state global international geographic location geography worldwide",
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "HorizontalFunnel",

        variations: "pyramid",

        allowHeader: true,
        availableHeaderPositions: [HeaderPositionType.TOP],
        availableTrayLayouts: [],

        allowColorful: true,

        defaultData: {
            primary: {
                ornament: "number",
                collectionColor: "theme-to-dark",
                showSectionDescriptions: true,
                showValues: true,
                funnel: [{ x: 0, y: 0, hx: 0.36, hy: 0 }, { x: 1, y: 1, hx: 0.85, hy: 0 }],
                items: [{}, {}, {}]
            }
        }
    }), getStaticProps: () => ({
        id: "horizontal-funnel",
        icon: "funnel_horizontal",
        title: "Horizontal Funnel",
        description: "Illustrate ordered stages across a horizontal slope, ramp, bump, wedge, funnel, or bowtie shape.",
        category: "diagram",
        tags: "horizontal funnel bowtie bow tie wedge slope ramp bump stages process flow lifecycle maturity continuum tapered mirrored funnel pipeline conversion steps",
        relatedTemplates: ["pyramid", "funnel"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "GraphicChart",

        allowHeader: true,
        availableHeaderPositions: [HeaderPositionType.TOP],
        availableTrayLayouts: [],

        allowColorful: true,

        defaultData: {
            primary: {
                items: [{}, {}, {}]
            }
        }
    }), getStaticProps: () => ({
        id: "graphic-chart",
        icon: "graphic-chart",
        title: "Graphic Chart",
        description: "",
        category: "diagram",
        tags: "",
        hideTemplate: true,
        relatedTemplates: [],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Sequence",
        variations: "process",
        allowHeader: true,
        allowColorful: true,
        availableHeaderPositions: [HeaderPositionType.TOP],
        availableTrayLayouts: [],

        defaultData: {
            primary: {
                shapeType: "diamond",
                items: [{}, {}, {}, {}, {}]
            }
        }
    }), getStaticProps: () => ({
        id: "sequence",
        icon: "sequence_diamond",
        title: "Sequence",
        description: "",
        category: "diagram",
        tags: "sequence gear puzzle process flow steps diamond",
        relatedTemplates: ["gears", "puzzle", "step_chevrons"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Sequence",
        variations: "process",
        allowHeader: true,
        allowColorful: true,
        availableHeaderPositions: [HeaderPositionType.TOP],
        availableTrayLayouts: [],

        defaultData: {
            primary: {
                shapeType: "gear",
                items: [{}, {}, {}, {}, {}]
            }
        }
    }), getStaticProps: () => ({
        id: "gears",
        icon: "sequence_gears",
        title: "Gears",
        description: "",
        category: "diagram",
        tags: "sequence gear puzzle process flow steps diamond",
        relatedTemplates: ["sequence", "puzzle", "step_chevrons"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "Sequence",
        variations: "process",
        allowHeader: true,
        allowColorful: true,
        availableHeaderPositions: [HeaderPositionType.TOP],
        availableTrayLayouts: [],

        defaultData: {
            primary: {
                shapeType: "puzzle",
                labelType: "none",
                items: [{}, {}, {}, {}, {}, {}]
            }
        }
    }), getStaticProps: () => ({
        id: "puzzle",
        icon: "sequence_puzzle",
        title: "Puzzle",
        description: "",
        category: "diagram",
        tags: "sequence gear puzzle process flow steps diamond",
        relatedTemplates: ["gears", "sequence", "step_chevrons"],
    })
});

templates.push({
    getInstanceProps: () => ({
        elementType: "GenerativeAIPlaceholder",

        allowHeader: false,
        allowFooter: false,
        availableTrayLayouts: [],
        canConvertToAuthoring: false,
        canSwitchTemplate: false,

        defaultData: {
        }
    }), getStaticProps: () => ({
        id: "ai-generation",
        title: "Generative AI Placeholder",
        hideTemplate: true
    })
});

module.exports = templates;
